(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-mockup-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var cfg = window.MS_CONFIG || {};
  var prices = cfg.prices || {};
  var variants = cfg.variants || {};
  var cloudinaryConfigured = !!(cfg.cloudinary && cfg.cloudinary.cloudName && cfg.cloudinary.preset);

  var STEPS = ['upload', 'vehicle', 'size', 'pack', 'result'];
  var STEP_TITLES = {
    upload:  'Upload your logo',
    vehicle: 'Your vehicle',
    size:    'Choose your size',
    pack:    'One door or both?',
    result:  'Here it is. Pick your favorite'
  };
  var SIZE_NAMES = { small: 'Starter · 35″×23″', medium: 'Standard · 55″×23″', large: 'Large · 75″×23″' };
  var SIZE_DIMS  = { small: '35″ × 23″', medium: '55″ × 23″', large: '75″ × 23″' };
  var PLAN_NAMES = { small: 'Starter', medium: 'Standard', large: 'Large' };
  var PACK_NAMES = { single: 'Single', double: '2-Pack: Both sides' };
  var STYLE_META = {
    border:   { name: 'White border', sub: 'A clean white edge hugging your logo' },
    redesign: { name: 'New design', sub: 'Your logo redrawn by AI to cut as one bold piece' }
  };
  /* White border shows the customer's own logo; the second option is a
     redesign in the logo maker's style, mocked up as a die-cut magnet. */
  var MOCKUP_STYLES = ['border', 'redesign'];
  var TURNSTILE_KEY = '0x4AAAAAAFT5ZQBY566-Kf9B';
  var MAX_REGENS = 2;
  /* Every request costs an AI render. Past this many in one visit, or when
     both versions fail, the customer continues in the classic editor. */
  var MAX_REQUESTS = 10;
  var SLOW_MS = 90000;

  var state = {
    step: 'upload',
    logoUrl: null, uploading: false, uploadFailed: false, hasFile: false,
    size: 'small', car: 'sedan', carLabel: 'Sedan', color: 'silver', colorName: 'Silver',
    pack: 'single',
    /* mockups[style] = { status: 'loading'|'done'|'error', url } */
    mockups: {}, genSig: null, selectedStyle: null, regens: 0, redesign: null,
    requests: 0, slowTimer: null, needFallback: false
  };
  var saveApi = null;

  function $(id) { return document.getElementById(id); }
  function apiBase() { return (cfg.apiUrl || '').replace(/\/+$/, ''); }
  function genSignature() { return [state.logoUrl, state.car, state.color, state.size].join('|'); }

  /* ── Wizard navigation ── */
  function go(step) {
    state.step = step;
    var shell = $('ms-step-result') && $('ms-step-result').closest('.ms__shell');
    if (shell) shell.classList.toggle('is-wide', step === 'result');
    STEPS.forEach(function (s) {
      var el = $('ms-step-' + s);
      if (el) el.hidden = (s !== step);
    });

    /* Replay the fade: drop the class, force a reflow, add it back */
    var shown = $('ms-step-' + step);
    if (shown) {
      shown.classList.remove('is-entering');
      void shown.offsetWidth;
      shown.classList.add('is-entering');
    }

    $('ms-title').textContent = STEP_TITLES[step];

    var idx = STEPS.indexOf(step);
    document.querySelectorAll('#ms-progress li').forEach(function (li) {
      var liIdx = STEPS.indexOf(li.dataset.step);
      li.classList.toggle('is-current', li.dataset.step === step);
      li.classList.toggle('is-done', liIdx < idx);
    });

    var nav = $('ms-nav');
    nav.hidden = (step === 'result');
    $('ms-back').hidden = (idx === 0);
    $('ms-next').textContent = (step === 'pack') ? 'See it on my car' : 'Continue';

    /* Everything needed for the mockups is known once size is chosen, so
       generation starts while the customer is still picking a quantity. */
    if (step === 'pack') startGeneration();
    if (step === 'result') {
      if (state.needFallback) { goClassic(); return; }
      startGeneration(); renderMockups(); syncSummary();
    }
    updateNextState();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function stepBlockReason() {
    if (state.step === 'upload') {
      if (!state.hasFile) return 'Upload your logo to continue.';
      if (state.uploading) return 'Uploading your logo…';
      if (state.uploadFailed) return 'Upload failed. Remove the file and try again.';
      if (cloudinaryConfigured && !state.logoUrl) return 'Uploading your logo…';
      return null;
    }
    return null; /* vehicle, size and pack always have a selection */
  }

  function updateNextState() {
    var next = $('ms-next');
    if (!next) return;
    next.disabled = !!stepBlockReason();
  }

  /* ── Upload ── */
  function uploadToCloudinary(file) {
    var cl = cfg.cloudinary || {};
    if (!cl.cloudName || !cl.preset) return;
    state.uploading = true;
    state.uploadFailed = false;
    state.logoUrl = null;
    setUploadStatus('uploading');
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', cl.preset);
    fetch('https://api.cloudinary.com/v1_1/' + cl.cloudName + '/auto/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        state.uploading = false;
        if (data.secure_url) {
          state.logoUrl = data.secure_url;
          if (state.thumbPending) {
            state.thumbPending = false;
            $('ms-thumb').src = data.secure_url.replace('/upload/', '/upload/f_png,pg_1,w_200/');
            $('ms-thumb').hidden = false;
          }
          setUploadStatus('done');
        } else {
          state.uploadFailed = true;
          setUploadStatus('error');
        }
      })
      .catch(function () {
        state.uploading = false;
        state.uploadFailed = true;
        setUploadStatus('error');
      });
  }

  function setUploadStatus(st) {
    var el = $('ms-upload-status');
    if (el) {
      el.className = 'ms__upload-status';
      if (st === 'uploading') { el.textContent = '⏳ Uploading file…'; el.classList.add('ms__upload-status--uploading'); }
      else if (st === 'done') { el.textContent = '✓ File saved';       el.classList.add('ms__upload-status--done'); }
      else if (st === 'error'){ el.textContent = '⚠ Upload failed';    el.classList.add('ms__upload-status--error'); }
      else { el.textContent = ''; }
    }
    updateNextState();
  }

  function loadLogo(file) {
    if (file.size > 10 * 1024 * 1024) {
      alert('That file is over 10 MB. Please choose a smaller one.');
      return;
    }
    state.hasFile = true;
    resetGenerated();
    uploadToCloudinary(file);
    var reader = new FileReader();
    var vector = /pdf|svg/i.test(file.type || '') || /\.(pdf|svg)$/i.test(file.name || '');
    state.thumbPending = vector;
    reader.onload = function (e) {
      /* Browsers cannot show a PDF in an <img>; its thumbnail comes from the
         PNG Cloudinary renders once the upload finishes. */
      if (!vector) { $('ms-thumb').src = e.target.result; $('ms-thumb').hidden = false; }
      else if (state.thumbPending) $('ms-thumb').hidden = true;
      $('ms-fname').textContent = file.name;
      $('ms-drop-empty').hidden = true;
      $('ms-drop-filled').hidden = false;
    };
    reader.readAsDataURL(file);
    updateNextState();
  }

  function ownUpload() {
    if (!state.logoBrief) return;
    state.logoBrief = null;
    document.dispatchEvent(new CustomEvent('md:logo-cleared'));
  }

  function clearLogo() {
    ownUpload();
    state.hasFile = false;
    state.logoUrl = null; state.uploading = false; state.uploadFailed = false;
    resetGenerated();
    $('ms-file').value = '';
    $('ms-drop-empty').hidden = false;
    $('ms-drop-filled').hidden = true;
    setUploadStatus('');
  }

  function resetGenerated() {
    state.mockups = {};
    state.genSig = null;
    state.selectedStyle = null;
  }

  /* ── Mockup generation: both styles in parallel ── */
  function startGeneration() {
    if (!apiBase() || !state.logoUrl) return;
    var sig = genSignature();
    if (state.genSig === sig) return; /* already generated / in flight for these options */
    state.genSig = sig;
    state.selectedStyle = null;
    state.mockups = {};
    MOCKUP_STYLES.forEach(function (style) { requestMockup(style, sig); });
    clearTimeout(state.slowTimer);
    state.slowTimer = setTimeout(function () {
      if (state.genSig === sig && !anyDone()) triggerFallback();
    }, SLOW_MS);
    var hint = $('ms-gen-hint');
    if (hint) hint.hidden = false;
    if (state.step === 'result') renderMockups();
    updateBuyState();
  }

  function requestMockup(style, sig) {
    state.requests++;
    if (state.requests > MAX_REQUESTS) {
      state.mockups[style] = { status: 'error', url: null };
      triggerFallback();
      return;
    }
    state.mockups[style] = { status: 'loading', url: null };
    if (style !== 'redesign') { postMockup(style, sig, state.logoUrl, style); return; }
    redesignLogo().then(function (url) {
      if (state.genSig !== sig) return;
      if (!url) { state.mockups[style] = { status: 'error', url: null }; onMockupSettled(); return; }
      postMockup(style, sig, url, 'sticker');
    });
  }

  /* One redesign per uploaded logo, reused across car and size changes;
     "Generate again" asks for a fresh one. */
  function redesignLogo() {
    var src = state.logoUrl;
    if (state.redesign && state.redesign.src === src) return state.redesign.promise;
    var job = { src: src, url: null };
    job.promise = (window.MDCut
      ? sourceColors(src).then(function (colors) {
          return MDCut.fixVersions({ api: apiBase(), sitekey: TURNSTILE_KEY, logoUrl: src, reason: 'ai studio redesign', versions: [3], colors: colors });
        }).then(function (urls) { return urls[0] ? transparentCopy(urls[0]) : null; })
      : Promise.resolve(null)
    ).then(function (url) {
      if (state.redesign === job) { if (url) job.url = url; else state.redesign = null; }
      return url;
    });
    state.redesign = job;
    return job.promise;
  }

  /* The redesign comes on plain white. Only the white touching the edges is
     background, so it is cleared from the edges inwards and the copy is
     uploaded: white inside the logo stays and the mockup can't cut it away. */
  function transparentCopy(url) {
    var cl = cfg.cloudinary || {};
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var art = MDMockup.prepareLogo(img, { removeBg: true, colour: 'original', max: 2400 });
          art.toBlob(function (blob) {
            if (!blob || !cl.cloudName || !cl.preset) return resolve(url);
            var fd = new FormData();
            fd.append('file', blob, 'logo-redesign.png');
            fd.append('upload_preset', cl.preset);
            fetch('https://api.cloudinary.com/v1_1/' + cl.cloudName + '/image/upload', { method: 'POST', body: fd })
              .then(function (r) { return r.json(); })
              .then(function (d) { resolve(d.secure_url || url); })
              .catch(function () { resolve(url); });
          }, 'image/png');
        } catch (e) { resolve(url); }
      };
      img.onerror = function () { resolve(url); };
      img.src = url;
    });
  }

  function sourceColors(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { try { resolve(MDCut.logoColors(img)); } catch (e) { resolve([]); } };
      img.onerror = function () { resolve([]); };
      img.src = src.replace('/upload/', '/upload/f_png,pg_1,w_400,c_limit/');
    });
  }

  function postMockup(style, sig, logoUrl, serverStyle) {
    fetch(apiBase() + '/mockup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        logoUrl: logoUrl,
        car: state.car,
        color: state.color,
        size: state.size,
        style: serverStyle
      })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        if (state.genSig !== sig) return; /* options changed mid-flight */
        state.mockups[style] = data.url
          ? { status: 'done', url: data.url }
          : { status: 'error', url: null };
        onMockupSettled();
      })
      .catch(function () {
        if (state.genSig !== sig) return;
        state.mockups[style] = { status: 'error', url: null };
        onMockupSettled();
      });
  }

  function onMockupSettled() {
    var pending = MOCKUP_STYLES.some(function (s) {
      return state.mockups[s] && state.mockups[s].status === 'loading';
    });
    if (!pending) {
      var hint = $('ms-gen-hint');
      if (hint) hint.hidden = true;
      if (!anyDone()) { triggerFallback(); return; }
    }
    /* White border comes pre-selected; die-cut only if the border version
       failed. The customer can still switch with one tap. */
    if (!state.selectedStyle) {
      var b = state.mockups.border, d = state.mockups.redesign;
      if (b && b.status === 'done') state.selectedStyle = 'border';
      else if (b && b.status === 'error' && d && d.status === 'done') state.selectedStyle = 'redesign';
      if (state.selectedStyle) syncSummary();
    }
    if (state.step === 'result') renderMockups();
    updateBuyState();
    if (saveApi) saveApi.refresh();
  }

  function anyDone() {
    return MOCKUP_STYLES.some(function (s) {
      return state.mockups[s] && state.mockups[s].status === 'done';
    });
  }

  /* No AI photo to show: send the customer to the classic editor with the
     same logo, vehicle, size and pack, so nothing has to be redone and the
     sale is not lost. The A/B assignment stays on this editor. */
  function triggerFallback() {
    clearTimeout(state.slowTimer);
    if (!state.logoUrl) return;
    if (state.step === 'result') goClassic();
    else state.needFallback = true;
  }

  function classicLink(fromAi) {
    var base = cfg.classicUrl || '/pages/customize';
    var q = 'logo=' + encodeURIComponent(state.logoUrl || '') +
            '&car=' + encodeURIComponent(state.car) +
            '&size=' + state.size + '&pack=' + state.pack;
    if (fromAi) q += '&from=ai&back=' + encodeURIComponent(window.location.pathname);
    return base + (base.indexOf('?') === -1 ? '?' : '&') + q;
  }

  function goClassic() {
    window.location.href = classicLink(true);
  }

  function renderMockups() {
    var wrap = $('ms-mockups');
    if (!wrap) return;
    wrap.innerHTML = '';

    /* No worker configured: no AI previews, but the purchase still works */
    if (!apiBase() || !state.logoUrl) {
      var note = document.createElement('p');
      note.className = 'ms__mockup-status';
      note.textContent = 'AI previews are unavailable right now. You can still place your order and we will prepare the cut for you.';
      wrap.appendChild(note);
      $('ms-result-actions').hidden = true;
      return;
    }

    MOCKUP_STYLES.forEach(function (style) {
      wrap.appendChild(mockupCard(style, state.mockups[style] || { status: 'loading' }));
    });

    var anyDone = MOCKUP_STYLES.some(function (s) {
      return state.mockups[s] && state.mockups[s].status === 'done';
    });
    var actions = $('ms-result-actions');
    actions.hidden = !anyDone;
    if (anyDone) {
      var regen = $('ms-regen');
      var left = MAX_REGENS - state.regens;
      regen.disabled = left <= 0;
      regen.textContent = left > 0 ? 'Generate again (' + left + ' left)' : 'No regenerations left';
    }
  }

  function mockupCard(style, m) {
    var meta = STYLE_META[style];
    /* A div, not a button: the card holds its own buttons (View, retry)
       and nesting interactive elements is invalid and breaks the layout. */
    var card = document.createElement('div');
    card.className = 'ms__mockup-card';
    card.setAttribute('role', 'radio');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-checked', state.selectedStyle === style ? 'true' : 'false');

    if (m.status === 'done') {
      var img = document.createElement('img');
      img.className = 'ms__mockup-img';
      img.alt = meta.name + ' mockup on your vehicle';
      img.src = m.url;
      card.appendChild(img);

      var expand = document.createElement('button');
      expand.type = 'button';
      expand.className = 'ms__expand';
      expand.setAttribute('aria-label', 'View ' + meta.name + ' full screen');
      expand.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>View';
      expand.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox(style);
      });
      card.appendChild(expand);
    } else if (m.status === 'error') {
      card.classList.add('is-error');
      var skelErr = document.createElement('div');
      skelErr.className = 'ms__mockup-skel';
      skelErr.style.animation = 'none';
      skelErr.style.background = '#fef2f2';
      card.appendChild(skelErr);
    } else {
      card.classList.add('is-loading');
      var skel = document.createElement('div');
      skel.className = 'ms__mockup-skel';
      var sp = document.createElement('div');
      sp.className = 'ms__spinner';
      skel.appendChild(sp);
      card.appendChild(skel);
    }

    card.setAttribute('aria-label', meta.name);

    if (m.status === 'loading') {
      var st = document.createElement('span');
      st.className = 'ms__mockup-status';
      st.textContent = 'Rendering… 20-60 seconds';
      card.appendChild(st);
    }
    if (m.status === 'error') {
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'ms__mockup-retry';
      retry.textContent = 'This one failed. Try again';
      retry.addEventListener('click', function (e) {
        e.stopPropagation();
        requestMockup(style, state.genSig);
        renderMockups();
      });
      card.appendChild(retry);
    }

    var check = document.createElement('span');
    check.className = 'ms__mockup-check';
    check.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    card.appendChild(check);

    if (state.selectedStyle === style) card.classList.add('is-selected');

    function pick() {
      if (!state.mockups[style] || state.mockups[style].status !== 'done') return;
      state.selectedStyle = style;
      renderMockups();
      syncSummary();
      updateBuyState();
      if (saveApi) saveApi.refresh();
    }
    card.addEventListener('click', pick);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });

    return card;
  }

  /* ── Fullscreen viewer ── */
  var lbStyle = null;

  function openLightbox(style) {
    var m = state.mockups[style];
    if (!m || m.status !== 'done') return;
    lbStyle = style;
    $('ms-lb-img').src = m.url;
    $('ms-lb-name').textContent = STYLE_META[style].name;
    $('ms-lb-pick').textContent = state.selectedStyle === style ? 'Selected' : 'Choose this one';
    $('ms-lightbox').hidden = false;
    document.body.style.overflow = 'hidden';
    $('ms-lb-close').focus();
  }

  function closeLightbox() {
    $('ms-lightbox').hidden = true;
    document.body.style.overflow = '';
    lbStyle = null;
  }

  /* ── Summary + buy ── */
  function priceKey() { return state.pack === 'double' ? state.size + '_double' : state.size; }

  function syncSummary() {
    $('ms-sum-style').textContent = state.selectedStyle
      ? STYLE_META[state.selectedStyle].name
      : 'Pick one above';
    $('ms-sum-size').textContent = SIZE_NAMES[state.size];
    $('ms-sum-car').textContent = state.colorName + ' ' + state.carLabel;

    /* Quantity picker: option prices track the chosen size */
    var p2s = $('ms-p2-single');
    var p2d = $('ms-p2-double');
    if (p2s) p2s.textContent = '$' + (prices[state.size] || '0');
    if (p2d) p2d.textContent = '$' + (prices[state.size + '_double'] || '0');
    document.querySelectorAll('.ms__pack2-opt').forEach(function (b) {
      b.classList.toggle('is-selected', b.dataset.pack === state.pack);
      b.setAttribute('aria-checked', b.dataset.pack === state.pack ? 'true' : 'false');
    });

    var price = prices[priceKey()];
    $('ms-price').textContent = price ? '$' + price : '';
    var was = $('ms-price-was');
    if (state.pack === 'double') {
      was.textContent = '$' + ((prices[state.size] || 0) * 2);
      was.hidden = false;
    } else {
      was.hidden = true;
    }
  }

  function buyBlockReason() {
    /* Only require a style pick when AI previews are actually available */
    if (apiBase() && state.logoUrl && !state.selectedStyle) return 'Pick the version you like to continue.';
    var aware = $('ms-aware');
    if (aware && !aware.checked) return 'Please confirm the surface notice above.';
    return null;
  }

  function updateBuyState() {
    var btn = $('ms-buy');
    var hint = $('ms-buy-hint');
    if (!btn) return;
    var reason = buyBlockReason();
    btn.disabled = !!reason;
    if (hint) { hint.textContent = reason || ''; hint.hidden = !reason; }
  }

  function placeOrder() {
    var vid = parseInt(variants[state.size + '_' + state.pack]);
    var errEl = $('ms-buy-err');
    if (errEl) { errEl.hidden = true; errEl.textContent = 'Something went wrong. Please try again.'; }

    var reason = buyBlockReason();
    if (reason) {
      if (errEl) { errEl.textContent = reason; errEl.hidden = false; }
      updateBuyState();
      return;
    }
    if (!vid) {
      if (errEl) { errEl.textContent = 'This size and pack combination is temporarily unavailable. Please contact us and we will sort it out.'; errEl.hidden = false; }
      return;
    }

    var selected = state.selectedStyle ? state.mockups[state.selectedStyle] : null;
    /* Same names in all three editors. Files carry a leading underscore so
       they stay out of the customer's emails; the admin order page, the
       packing slip and the staff notices show them. */
    var props = {
      'Plan': PLAN_NAMES[state.size],
      'Pack': PACK_NAMES[state.pack],
      'Size': 'Up to ' + SIZE_DIMS[state.size],
      'Cut style': state.selectedStyle ? STYLE_META[state.selectedStyle].name : 'To be prepared by our team',
      'Vehicle': state.carLabel,
      'Paint': state.colorName,
      'Price': '$' + (prices[priceKey()] || '0'),
      '_Editor': 'ai-studio'
    };
    if (state.logoUrl) props['_Logo file'] = state.logoUrl;
    if (state.selectedStyle === 'redesign' && state.redesign && state.redesign.url) {
      props['Cut style'] = 'Fully die-cut';
      props['Logo'] = 'Redesigned by AI';
      props['_Logo file'] = state.redesign.url;
      props['_Original logo'] = state.logoUrl;
    }
    if (state.logoBrief) {
      var b = state.logoBrief;
      props['Logo'] = 'Created with AI';
      props['_Logo brief'] = [b.name, b.line, b.industry, b.about, b.type, b.style, b.colors].filter(Boolean).join(' · ');
      if (state.logoRefUrl) props['_Logo reference'] = state.logoRefUrl;
    }
    if (selected && selected.url) props['_Mockup'] = selected.url;

    var btn = $('ms-buy');
    btn.disabled = true;
    btn.style.opacity = '0.7';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          });
        }
        /* /discount/<code>?redirect=… is Shopify's documented discount-link
           format: it applies the code and then lands on checkout, so the
           customer never types it in. Falls through to plain checkout when
           no code is configured. */
        var promoEl = $('ms-promo');
        var code = promoEl && promoEl.dataset.code ? promoEl.dataset.code : '';
        window.location.href = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
          : '/checkout';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.style.opacity = '';
        if (errEl) {
          if (err && err.message && err.message !== 'Could not add to cart') errEl.textContent = err.message;
          errEl.hidden = false;
        }
      });
  }

  /* ── Wire ── */
  function wire() {
    var drop = $('ms-drop');
    var input = $('ms-file');
    drop.addEventListener('click', function (e) { if (!e.target.closest('#ms-remove')) input.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
    drop.addEventListener('drop', function (e) {
      e.preventDefault(); drop.classList.remove('is-over');
      if (e.dataTransfer.files[0]) { ownUpload(); loadLogo(e.dataTransfer.files[0]); }
    });
    input.addEventListener('change', function () { if (input.files[0]) { ownUpload(); loadLogo(input.files[0]); } });
    /* The logo maker hands over a finished PNG; from here it is an upload
       like any other. */
    document.addEventListener('md:logo-made', function (e) {
      state.logoBrief = e.detail.brief;
      /* The customer's old logo or business photo goes to the designer
         who prepares the print file. */
      state.logoRefUrl = e.detail.referenceUrl || null;
      loadLogo(e.detail.file);
    });
    $('ms-remove').addEventListener('click', function (e) { e.stopPropagation(); clearLogo(); });

    document.querySelectorAll('input[name="ms-size"]').forEach(function (r) {
      r.addEventListener('change', function () {
        r.closest('.ms__options').querySelectorAll('.ms__opt').forEach(function (o) { o.classList.remove('is-selected'); });
        r.closest('.ms__opt').classList.add('is-selected');
        state.size = r.value;
      });
    });

    document.querySelectorAll('input[name="ms-pack"]').forEach(function (r) {
      r.addEventListener('change', function () {
        r.closest('.ms__options').querySelectorAll('.ms__opt').forEach(function (o) { o.classList.remove('is-selected'); });
        r.closest('.ms__opt').classList.add('is-selected');
        state.pack = r.value;
      });
    });

    /* Result-screen quantity picker mirrors the step 4 choice both ways */
    document.querySelectorAll('.ms__pack2-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        state.pack = b.dataset.pack;
        document.querySelectorAll('input[name="ms-pack"]').forEach(function (r) {
          r.checked = (r.value === state.pack);
          r.closest('.ms__opt').classList.toggle('is-selected', r.value === state.pack);
        });
        syncSummary();
      });
    });

    document.querySelectorAll('.ms__car').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.ms__car').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.car = btn.dataset.car;
        state.carLabel = btn.dataset.label;
      });
    });

    document.querySelectorAll('.ms__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.ms__swatch').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.color = btn.dataset.color;
        state.colorName = btn.dataset.name;
        $('ms-color-name').textContent = state.colorName;
      });
    });

    $('ms-next').addEventListener('click', function () {
      var idx = STEPS.indexOf(state.step);
      if (!stepBlockReason() && idx < STEPS.length - 1) go(STEPS[idx + 1]);
    });
    $('ms-back').addEventListener('click', function () {
      var idx = STEPS.indexOf(state.step);
      if (idx > 0) go(STEPS[idx - 1]);
    });

    /* Completed progress steps are clickable shortcuts back */
    document.querySelectorAll('#ms-progress li').forEach(function (li) {
      li.addEventListener('click', function () {
        if (li.classList.contains('is-done')) go(li.dataset.step);
      });
    });

    $('ms-regen').addEventListener('click', function () {
      if (state.regens >= MAX_REGENS) return;
      state.regens += 1;
      state.genSig = null; /* force a fresh pair */
      state.redesign = null;
      startGeneration();
      renderMockups();
    });
    $('ms-edit').addEventListener('click', function () { go('vehicle'); });

    /* Fullscreen viewer */
    $('ms-lb-close').addEventListener('click', closeLightbox);
    $('ms-lb-overlay').addEventListener('click', closeLightbox);
    $('ms-lb-pick').addEventListener('click', function () {
      if (!lbStyle) return;
      state.selectedStyle = lbStyle;
      renderMockups();
      syncSummary();
      updateBuyState();
      closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !$('ms-lightbox').hidden) closeLightbox();
    });

    /* Discount code copy */
    var promoCopy = $('ms-promo-copy');
    if (promoCopy) {
      promoCopy.addEventListener('click', function () {
        var code = ($('ms-promo') || {}).dataset ? $('ms-promo').dataset.code : '';
        var done = function () {
          promoCopy.textContent = 'Copied';
          setTimeout(function () { promoCopy.textContent = 'Copy'; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, function () {});
        } else {
          /* Older in-app browsers have no clipboard API — select-and-copy */
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch (err) {}
          document.body.removeChild(ta);
        }
      });
    }

    var aware = $('ms-aware');
    if (aware) aware.addEventListener('change', updateBuyState);
    $('ms-buy').addEventListener('click', placeOrder);
  }

  function init() {
    if (!$('ms-root')) return;

    /* This section carries a scroll-reveal transform, and a transformed
       ancestor becomes the containing block for position:fixed children,
       which would drop the viewer into the middle of the section instead
       of the viewport. Re-parenting to <body> keeps it fixed to the
       screen. Same fix the classic customizer's modal needed. */
    var lb = $('ms-lightbox');
    if (lb && lb.parentNode !== document.body) {
      document.querySelectorAll('body > .mslb').forEach(function (stale) {
        if (stale !== lb) stale.remove();
      });
      document.body.appendChild(lb);
    }

    wire();
    go('upload');
    restoreLogo();
    mountSave();
  }

  /* ?logo=… reopens the studio with a logo already uploaded (links in the
     logo maker emails). Only files from the store's own Cloudinary. */
  function restoreLogo() {
    var url;
    try { url = new URLSearchParams(window.location.search).get('logo'); } catch (e) { return; }
    var cl = cfg.cloudinary || {};
    if (!url || !cl.cloudName || url.indexOf('https://res.cloudinary.com/' + cl.cloudName + '/image/upload/') !== 0) return;
    state.hasFile = true;
    state.logoUrl = url;
    $('ms-thumb').src = url.replace('/upload/', '/upload/f_png,w_200/');
    $('ms-thumb').hidden = false;
    $('ms-fname').textContent = 'Your logo';
    $('ms-drop-empty').hidden = true;
    $('ms-drop-filled').hidden = false;
    setUploadStatus('done');
  }

  function chosenMockup() {
    var st = state.selectedStyle;
    if (st && state.mockups[st] && state.mockups[st].status === 'done') return { style: st, url: state.mockups[st].url };
    for (var i = 0; i < MOCKUP_STYLES.length; i++) {
      var m = state.mockups[MOCKUP_STYLES[i]];
      if (m && m.status === 'done') return { style: MOCKUP_STYLES[i], url: m.url };
    }
    return null;
  }

  function mountSave() {
    if (!window.MDSaveDesign || !$('ms-save')) return;
    saveApi = window.MDSaveDesign.mount({
      root: $('ms-save'),
      previewRoot: $('ms-save-quick'),
      canPrompt: function () { return !!(state.logoUrl && chosenMockup()); },
      getDesign: function (cb) {
        var m = chosenMockup();
        cb({
          mockupUrl: m ? m.url : '',
          /* Reopens the design in the classic editor: instant and free,
             unlike generating new AI photos. */
          restoreUrl: window.location.origin + classicLink(false),
          plan: PLAN_NAMES[state.size] + ' · ' + PACK_NAMES[state.pack],
          cutLabel: m ? STYLE_META[m.style].name : '',
          carType: state.colorName + ' ' + state.carLabel,
          editor: 'ai-studio'
        });
      }
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    

(function () {
  /* Keyboard accessibility — highlight row on focus within */
  document.querySelectorAll('[data-cmp-row]').forEach(function (row) {
    row.addEventListener('mouseenter', function () {
      row.classList.add('cmp__row--active');
    });
    row.addEventListener('mouseleave', function () {
      row.classList.remove('cmp__row--active');
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  (function () {
    'use strict';

    var STORE_KEY = 'md_first_order_popup';
    var CLEAR_TO_REVEAL = 0.42; /* fraction scratched before it opens itself */

    function readState() {
      try {
        return JSON.parse(window.localStorage.getItem(STORE_KEY) || 'null');
      } catch (e) {
        return null;
      }
    }

    function writeState(status) {
      try {
        window.localStorage.setItem(STORE_KEY, JSON.stringify({ status: status, at: Date.now() }));
      } catch (e) {
        /* private mode, or storage disabled: the popup simply shows again next visit */
      }
    }

    function init() {
      var pop = document.getElementById('md-popup');
      if (!pop || pop.dataset.mdpopBound) return;
      pop.dataset.mdpopBound = '1';

      var sectionEl = pop.closest('.shopify-section');

      /* The section wrapper can pick up a scroll-reveal transform, which would
         become the containing block for this fixed overlay. Re-parenting to
         <body> keeps it anchored to the viewport. */
      if (pop.parentNode !== document.body) {
        document.querySelectorAll('body > .mdpop').forEach(function (stale) {
          if (stale !== pop) stale.remove();
        });
        document.body.appendChild(pop);
      }

      var params = new URLSearchParams(window.location.search);
      var previewing = params.get('mdpop') === 'preview';
      var inEditor = !!window.Shopify && !!window.Shopify.designMode;

      /* Gating: already subscribed never sees it again; a dismissal rests for
         the configured number of days. Bypassed when previewing or in the
         theme editor so the section stays workable. */
      if (!previewing && !inEditor) {
        var state = readState();
        if (state && state.status === 'subscribed') return;
        if (state && state.status === 'dismissed') {
          var days = parseInt(pop.dataset.remindDays, 10);
          if (isNaN(days)) days = 14;
          if (Date.now() - (state.at || 0) < days * 864e5) return;
        }
      }

      var dialog = pop.querySelector('.mdpop__dialog');
      var stepEmail = document.getElementById('mdpop-step-email');
      var stepScratch = document.getElementById('mdpop-step-scratch');
      var form = document.getElementById('mdpop-form');
      var submitBtn = document.getElementById('mdpop-submit');
      var emailInput = document.getElementById('mdpop-email');
      var opened = false;

      /* ── Open and close ── */
      function open() {
        if (opened) return;
        opened = true;
        pop.hidden = false;
        document.body.style.overflow = 'hidden';
        /* Focus the field on desktop only: on touch this would throw up the
           keyboard over the offer they have not read yet. */
        if (window.matchMedia('(pointer: fine)').matches) {
          window.setTimeout(function () {
            if (emailInput) emailInput.focus({ preventScroll: true });
          }, 260);
        }
      }

      function close() {
        pop.hidden = true;
        document.body.style.overflow = '';
        if (inEditor || previewing) return;
        /* Someone who reached the code has already subscribed: keep that. */
        var current = readState();
        if (current && current.status === 'subscribed') return;
        writeState('dismissed');
      }

      pop.querySelectorAll('[data-mdpop-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pop.hidden) close();
      });

      /* ── Triggers ── */
      if (inEditor) {
        /* Opening on every editor load would bury whatever else they are
           editing, so follow the section selection instead. */
        document.addEventListener('shopify:section:select', function (e) {
          if (e.target === sectionEl) open();
        });
        document.addEventListener('shopify:section:deselect', close);
      } else if (previewing) {
        open();
      } else {
        var delay = parseInt(pop.dataset.delay, 10);
        if (isNaN(delay)) delay = 8;
        window.setTimeout(open, delay * 1000);

        if (pop.dataset.exitIntent === 'true') {
          document.addEventListener('mouseout', function (e) {
            if (!e.relatedTarget && e.clientY <= 0) open();
          });
        }
      }

      /* ── Step 1 to step 2 ── */
      function toScratch() {
        writeState('subscribed');
        if (stepEmail) stepEmail.hidden = true;
        if (stepScratch) stepScratch.hidden = false;
        if (dialog) dialog.scrollTop = 0;
        initScratch();
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!form.checkValidity()) { form.reportValidity(); return; }
          submitBtn.disabled = true;
          submitBtn.textContent = 'One moment…';
          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' }
          })
            .then(toScratch)
            .catch(function () {
              /* Network failure: hand them the code anyway rather than
                 punishing them for our problem. Shopify keeps no record, so
                 this is the one case where the email is lost. */
              toScratch();
            });
        });
      }

      /* ── Sound: a short filtered-noise scrape, synthesised so the theme
         carries no audio asset. Starts only from a pointer gesture. ── */
      var audio = null;
      var noiseBuffer = null;

      function ensureAudio() {
        if (pop.dataset.sound !== 'true') return null;
        if (audio) return audio;
        var Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return null;
        try {
          audio = new Ctx();
          var frames = audio.sampleRate * 0.4;
          noiseBuffer = audio.createBuffer(1, frames, audio.sampleRate);
          var data = noiseBuffer.getChannelData(0);
          for (var i = 0; i < frames; i++) data[i] = Math.random() * 2 - 1;
        } catch (e) {
          audio = null;
        }
        return audio;
      }

      var scrapeUntil = 0;

      function playScrape() {
        var ctx = ensureAudio();
        if (!ctx || !noiseBuffer) return;
        if (ctx.state === 'suspended') ctx.resume();
        var now = ctx.currentTime;
        if (now < scrapeUntil) return; /* one grain at a time */
        scrapeUntil = now + 0.07;

        var src = ctx.createBufferSource();
        src.buffer = noiseBuffer;
        src.loop = true;

        var filter = ctx.createBiquadFilter();
        filter.type = 'bandpass';
        filter.frequency.value = 1600 + Math.random() * 900;
        filter.Q.value = 0.9;

        var gain = ctx.createGain();
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(0.05, now + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.11);

        src.connect(filter).connect(gain).connect(ctx.destination);
        src.start(now);
        src.stop(now + 0.13);
      }

      function buzz(pattern) {
        try {
          if (navigator.vibrate) navigator.vibrate(pattern);
        } catch (e) { /* unsupported */ }
      }

      /* ── Scratch canvas ── */
      var scratchReady = false;

      function initScratch() {
        if (scratchReady) return;

        var card = document.getElementById('mdpop-card');
        var canvas = document.getElementById('mdpop-scratch');
        var revealBtn = document.getElementById('mdpop-reveal');
        if (!card || !canvas) return;

        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = 0;
        var h = 0;
        var revealed = false;
        var drawing = false;
        var painted = false;
        var last = null;
        var lastCheck = 0;
        var travel = 0; /* px dragged: a tap must never count as scratching */

        function radius() {
          return Math.max(18, w * 0.085);
        }

        function paintFoil() {
          var rect = card.getBoundingClientRect();

          /* If the card has no layout yet we must not paint. A 1x1 canvas is
             wiped out by the first touch, which used to read as 100% cleared
             and reveal the code before anyone could scratch it. */
          if (rect.width < 40 || rect.height < 20) return false;

          w = Math.round(rect.width);
          h = Math.round(rect.height);
          canvas.width = w * dpr;
          canvas.height = h * dpr;
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          ctx.globalCompositeOperation = 'source-over';

          var foil = ctx.createLinearGradient(0, 0, w, h);
          foil.addColorStop(0, '#f6c56a');
          foil.addColorStop(0.35, '#e8932f');
          foil.addColorStop(0.55, '#f7d79b');
          foil.addColorStop(0.75, '#dc8a24');
          foil.addColorStop(1, '#c57d28');
          ctx.fillStyle = foil;
          ctx.fillRect(0, 0, w, h);

          /* Speckle so the foil catches the eye as it breaks up */
          for (var i = 0; i < (w * h) / 220; i++) {
            var x = Math.random() * w;
            var y = Math.random() * h;
            ctx.fillStyle = Math.random() > 0.5 ? 'rgba(255,255,255,0.20)' : 'rgba(120,70,10,0.10)';
            ctx.fillRect(x, y, 1.6, 1.6);
          }

          /* Diagonal shine */
          var shine = ctx.createLinearGradient(0, h, w, 0);
          shine.addColorStop(0, 'rgba(255,255,255,0)');
          shine.addColorStop(0.45, 'rgba(255,255,255,0.30)');
          shine.addColorStop(0.6, 'rgba(255,255,255,0)');
          ctx.fillStyle = shine;
          ctx.fillRect(0, 0, w, h);

          ctx.fillStyle = 'rgba(92, 53, 6, 0.72)';
          ctx.font = '700 ' + Math.max(11, Math.round(w * 0.038)) + 'px system-ui, -apple-system, sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.letterSpacing = '2px';
          ctx.fillText('SCRATCH HERE', w / 2, h / 2 + 1);

          painted = true;
          return true;
        }

        function pointFrom(e) {
          var rect = canvas.getBoundingClientRect();
          /* The canvas is stretched to the card by CSS, so map client px onto
             the drawing surface rather than assuming they match. */
          var sx = rect.width ? w / rect.width : 1;
          var sy = rect.height ? h / rect.height : 1;
          return { x: (e.clientX - rect.left) * sx, y: (e.clientY - rect.top) * sy };
        }

        function scratchTo(p) {
          if (!painted) return;
          var r = radius();

          ctx.save();
          ctx.globalCompositeOperation = 'destination-out';
          /* Both must be fully opaque. The foil text left fillStyle at 72%
             alpha, so every dab only removed 72% of the foil and the card
             never actually cleared. */
          ctx.fillStyle = '#000';
          ctx.strokeStyle = '#000';
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.lineWidth = r * 2;

          if (last) {
            ctx.beginPath();
            ctx.moveTo(last.x, last.y);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
            travel += Math.sqrt((p.x - last.x) * (p.x - last.x) + (p.y - last.y) * (p.y - last.y));
          }

          ctx.beginPath();
          ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
          ctx.fill();
          ctx.restore();

          last = p;
        }

        function clearedFraction() {
          if (!painted || canvas.width < 8 || canvas.height < 8) return 0;
          var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          var clear = 0;
          var total = 0;
          /* Sample every 8th pixel: plenty for a threshold, cheap to run */
          for (var i = 3; i < data.length; i += 32) {
            total++;
            if (data[i] < 24) clear++;
          }
          return total ? clear / total : 0;
        }

        /* Auto-reveal needs real scratching, not one stationary touch. */
        function scratchedEnough(threshold) {
          if (travel < radius() * 4) return false;
          return clearedFraction() >= threshold;
        }

        function reveal(fromScratch) {
          if (revealed) return;
          revealed = true;
          card.classList.add('is-revealed');
          if (revealBtn) revealBtn.hidden = true;
          var done = document.getElementById('mdpop-done');
          if (done) done.hidden = false;
          buzz([12, 40, 26]);
          if (fromScratch) confetti();
        }

        /* Bind only once the foil is really on screen; until then retry on the
           next frame so a card that has not been laid out yet cannot arm a
           broken canvas. */
        var tries = 0;
        function arm() {
          if (paintFoil()) {
            scratchReady = true;
            return;
          }
          if (tries++ < 60) requestAnimationFrame(arm);
        }
        arm();

        if (window.ResizeObserver) {
          var ro = new ResizeObserver(function () {
            if (revealed) return;
            var rect = card.getBoundingClientRect();
            if (rect.width < 40 || rect.height < 20) return;
            if (Math.round(rect.width) === w && Math.round(rect.height) === h) return;
            /* Repainting throws away whatever they already scratched off, so
               only re-cut the foil while the card is still untouched. */
            if (travel > 0 || !painted) {
              if (!painted) paintFoil();
              return;
            }
            paintFoil();
          });
          ro.observe(card);
        }

        canvas.addEventListener('pointerdown', function (e) {
          if (revealed || !painted) return;
          e.preventDefault();
          drawing = true;
          last = null;
          try { canvas.setPointerCapture(e.pointerId); } catch (err) { /* older Safari */ }
          scratchTo(pointFrom(e));
          playScrape();
          buzz(8);
        });

        canvas.addEventListener('pointermove', function (e) {
          if (!drawing || revealed) return;
          scratchTo(pointFrom(e));
          playScrape();
          var now = performance.now();
          if (now - lastCheck > 150) {
            lastCheck = now;
            if (scratchedEnough(CLEAR_TO_REVEAL)) reveal(true);
          }
        });

        function endStroke() {
          if (!drawing) return;
          drawing = false;
          last = null;
          if (!revealed && scratchedEnough(CLEAR_TO_REVEAL * 0.85)) reveal(true);
        }

        canvas.addEventListener('pointerup', endStroke);
        canvas.addEventListener('pointercancel', endStroke);
        canvas.addEventListener('pointerleave', endStroke);

        if (revealBtn) revealBtn.addEventListener('click', function () { reveal(false); });

        /* Keyboard and reduced-motion users get there without dragging */
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (revealBtn) revealBtn.textContent = 'Show my code';
        }
      }

      /* ── Confetti burst, drawn on its own canvas over the card ── */
      function confetti() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var canvas = document.getElementById('mdpop-confetti');
        var card = document.getElementById('mdpop-card');
        if (!canvas || !card) return;

        var ctx = canvas.getContext('2d');
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var rect = card.getBoundingClientRect();
        var w = rect.width;
        var h = rect.height;
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        var colors = ['#e8932f', '#f6c56a', '#111827', '#16a34a', '#ffffff'];
        var bits = [];
        for (var i = 0; i < 46; i++) {
          var angle = Math.random() * Math.PI * 2;
          var speed = 2 + Math.random() * 4.5;
          bits.push({
            x: w / 2,
            y: h / 2,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed - 2,
            size: 3 + Math.random() * 4,
            rot: Math.random() * Math.PI,
            vr: (Math.random() - 0.5) * 0.4,
            color: colors[(Math.random() * colors.length) | 0],
            life: 1
          });
        }

        var start = performance.now();
        (function frame(now) {
          var elapsed = now - start;
          ctx.clearRect(0, 0, w, h);
          bits.forEach(function (b) {
            b.vy += 0.16;
            b.x += b.vx;
            b.y += b.vy;
            b.rot += b.vr;
            b.life = Math.max(0, 1 - elapsed / 1100);
            ctx.save();
            ctx.globalAlpha = b.life;
            ctx.translate(b.x, b.y);
            ctx.rotate(b.rot);
            ctx.fillStyle = b.color;
            ctx.fillRect(-b.size / 2, -b.size / 2, b.size, b.size * 0.6);
            ctx.restore();
          });
          if (elapsed < 1100) {
            requestAnimationFrame(frame);
          } else {
            ctx.clearRect(0, 0, w, h);
          }
        })(start);
      }

      /* ── Copy the code ── */
      var copyBtn = document.getElementById('mdpop-copy');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = pop.dataset.code || '';
          var label = document.getElementById('mdpop-copy-label');
          var original = label ? label.textContent : '';

          function flash() {
            copyBtn.classList.add('is-copied');
            if (label) label.textContent = 'Copied';
            window.setTimeout(function () {
              copyBtn.classList.remove('is-copied');
              if (label) label.textContent = original;
            }, 1800);
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(flash, fallback);
          } else {
            fallback();
          }

          function fallback() {
            var tmp = document.createElement('textarea');
            tmp.value = code;
            tmp.setAttribute('readonly', '');
            tmp.style.position = 'absolute';
            tmp.style.left = '-9999px';
            document.body.appendChild(tmp);
            tmp.select();
            try { document.execCommand('copy'); flash(); } catch (e) { /* nothing to do */ }
            document.body.removeChild(tmp);
          }
        });
      }

      /* Carry the code into the cart so it is already applied when they land */
      var cta = document.getElementById('mdpop-cta');
      if (cta && pop.dataset.code) {
        var dest = cta.getAttribute('href') || '/';
        cta.setAttribute('href', '/discount/' + encodeURIComponent(pop.dataset.code) + '?redirect=' + encodeURIComponent(dest));
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── Comparison slider ─────────────────────────────────────────── */
  function initSliders() {
    document.querySelectorAll('.hiw__cs:not([data-cs-init])').forEach(function (cs) {
      cs.setAttribute('data-cs-init', '1');
      var range = cs.querySelector('.hiw__cs-range');
      if (!range) return;

      function update(x) {
        var rect = cs.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
        cs.style.setProperty('--pos', pct + '%');
        range.value = pct;
      }

      range.addEventListener('input', function () {
        cs.style.setProperty('--pos', range.value + '%');
      });

      cs.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        cs.setPointerCapture(e.pointerId);
        update(e.clientX);
      });

      cs.addEventListener('pointermove', function (e) {
        if (!cs.hasPointerCapture(e.pointerId)) return;
        update(e.clientX);
      });
    });
  }

  /* ── Scroll animations ─────────────────────────────────────────── */
  function initAnimations() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -50px 0px', threshold: 0.06 });

    function observe(el) {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('is-visible');
      } else {
        el.classList.add('will-animate');
        io.observe(el);
      }
    }

    function setupReveal(sel) {
      document.querySelectorAll(sel + ':not([data-hiw-init])').forEach(function (el) {
        el.setAttribute('data-hiw-init', '1');
        el.classList.add('hiw-reveal');
        observe(el);
      });
    }

    function setupStagger(containerSel, itemSel) {
      document.querySelectorAll(containerSel + ':not([data-hiw-init])').forEach(function (el) {
        el.setAttribute('data-hiw-init', '1');
        el.classList.add('hiw-stagger');
        el.querySelectorAll(itemSel).forEach(function (item) {
          item.classList.add('hiw-stagger__item');
        });
        observe(el);
      });
    }

    /* Fade-up — individual elements */
    setupReveal('.hiw__hero-sub');
    setupReveal('.hiw__stats');
    setupReveal('.hiw__compare-hint');
    setupReveal('.hiw__compare-section .hiw__cs');
    setupReveal('.hiw__what .hiw__h2');
    setupReveal('.hiw__what .hiw__lead');
    setupReveal('.hiw__process .hiw__h2');
    setupReveal('.hiw__compat .hiw__h2');
    setupReveal('.hiw__compat .hiw__lead');
    setupReveal('.hiw__tip');
    setupReveal('.hiw__faq-wrap .hiw__h2');
    setupReveal('.hiw__cta-title');
    setupReveal('.hiw__cta-sub');
    setupReveal('.hiw__cta-btns');

    /* Stagger — groups */
    setupStagger('.hiw__pillars',    '.hiw__pillar');
    setupStagger('.hiw__process-grid', '.hiw__process-step');
    setupStagger('.hiw__compat-cols',  '.hiw__compat-col');
    setupStagger('.hiw__faq',        '.hiw__faq-item');
  }

  function init() {
    initSliders();
    initAnimations();
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initSliders() {
      document.querySelectorAll('.lhero__cs:not([data-cs-init])').forEach(function (cs) {
        cs.setAttribute('data-cs-init', '1');
        var range = cs.querySelector('.lhero__cs-range');
        if (!range) return;

        var hintFrame = null;

        function setPos(pct) {
          cs.style.setProperty('--pos', pct + '%');
          range.value = pct;
        }

        function update(x) {
          var rect = cs.getBoundingClientRect();
          var pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
          setPos(pct);
        }

        /* One nudge left and right on first view, so it reads as draggable. */
        function stopHint() {
          if (hintFrame) cancelAnimationFrame(hintFrame);
          hintFrame = null;
          cs.classList.remove('is-hinting');
        }

        function playHint() {
          if (reduceMotion || cs.hasAttribute('data-cs-hinted')) return;
          cs.setAttribute('data-cs-hinted', '1');
          cs.classList.add('is-hinting');

          var stops = [50, 72, 28, 50];
          var leg = 620;
          var total = leg * (stops.length - 1);
          var start = null;

          function frame(now) {
            if (start === null) start = now;
            var t = Math.min(1, (now - start) / total);
            var at = t * (stops.length - 1);
            var i = Math.min(stops.length - 2, Math.floor(at));
            var local = at - i;
            var eased = local < 0.5
              ? 4 * local * local * local
              : 1 - Math.pow(-2 * local + 2, 3) / 2;
            setPos(stops[i] + (stops[i + 1] - stops[i]) * eased);
            if (t < 1) {
              hintFrame = requestAnimationFrame(frame);
            } else {
              stopHint();
            }
          }

          hintFrame = requestAnimationFrame(frame);
        }

        range.addEventListener('input', function () {
          stopHint();
          cs.setAttribute('data-cs-hinted', '1');
          cs.style.setProperty('--pos', range.value + '%');
        });

        cs.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          stopHint();
          cs.setAttribute('data-cs-hinted', '1');
          cs.setPointerCapture(e.pointerId);
          update(e.clientX);
        });

        cs.addEventListener('pointermove', function (e) {
          if (!cs.hasPointerCapture(e.pointerId)) return;
          update(e.clientX);
        });

        /* Wait until the images are up and the slider is on screen. */
        function armHint() {
          if (!('IntersectionObserver' in window)) {
            setTimeout(playHint, 700);
            return;
          }
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              io.disconnect();
              setTimeout(playHint, 450);
            });
          }, { threshold: 0.35 });
          io.observe(cs);
        }

        if (document.readyState === 'complete') {
          armHint();
        } else {
          window.addEventListener('load', armHint, { once: true });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliders);
    } else {
      initSliders();
    }
    document.addEventListener('shopify:section:load', initSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-customizer"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var cfg      = window.CZ_CONFIG || {};
  var carUrls  = cfg.carUrls  || {};
  var prices   = cfg.prices   || { small: 75, medium: 115, large: 165, small_double: 131, medium_double: 201, large_double: 289 };
  var zones    = cfg.zones    || {};
  var variants = cfg.variants || {};
  var cloudinaryConfigured = !!(cfg.cloudinary && cfg.cloudinary.cloudName && cfg.cloudinary.preset);

  var SIZE_DIMS  = { small: [35,23], medium: [55,23], large: [75,23] };
  var SIZE_NAMES = { small: 'Starter · 35″×23″', medium: 'Standard · 55″×23″', large: 'Large · 75″×23″' };
  var PACK_NAMES = { single: 'Single', double: '2-Pack: Both sides' };

  var MD = window.MDMockup;
  var PLAN_NAMES = { small: 'Starter', medium: 'Standard', large: 'Large' };

  var state = { car: null, carLabel: '', size: 'small', pack: 'single', color: 'original', colorName: 'Original', uploadUrl: null, uploading: false, uploadFailed: false, removeBg: false, bgDetected: false, fallback: false, fix: { stage: 'idle' } };
  /* ox, oy: offset of the logo from the magnet centre in inches; k: size
     relative to the largest fit. Kept in real units so the customer's
     adjustments survive switching car or size. */
  var logo  = { img: null, cx: 0, cy: 0, w: 0, h: 0, r: 0, ox: 0, oy: 0, k: 1, prepared: null, preparedKey: '' };
  var saveApi = null;
  var drag  = { on: false, handle: null, sx: 0, sy: 0, ox: 0, oy: 0, ow: 0, oh: 0, or: 0, sa: 0, sd: 0 };
  var canvas, ctx, carCache = {}, isExporting = false;

  /* ── Init ── */
  function init() {
    canvas = document.getElementById('cz-canvas');
    if (!canvas) return;
    ctx = canvas.getContext('2d');

    var firstTab = document.querySelector('.cz__frame-tab.is-active');
    if (firstTab) activateCar(firstTab);

    var originalSwatch = document.querySelector('.cz__swatch--original');
    if (originalSwatch) originalSwatch.classList.add('is-active');

    syncSummary();
    setDeliveryDate();
    wire();
    updateBuyState();
    applyFallbackParams();
    mountSave();
  }

  /* ── Buy button gating — everything required before checkout ── */
  function buyBlockReason() {
    if (!logo.img) return 'Upload your logo to continue.';
    if (state.uploading) return 'Please wait, your logo is uploading…';
    if (state.uploadFailed) return 'Upload failed. Remove and re-upload your logo.';
    if (cloudinaryConfigured && !state.uploadUrl) return 'Please wait, your logo is uploading…';
    var aware = document.getElementById('cz-aware');
    if (aware && !aware.checked) return 'Please confirm the surface notice above.';
    return null;
  }

  function updateBuyState() {
    var btn  = document.getElementById('cz-buy');
    var hint = document.getElementById('cz-buy-hint');
    if (!btn) return;
    var reason = buyBlockReason();
    btn.disabled = !!reason;
    if (hint) {
      hint.textContent = reason || '';
      hint.hidden = !reason;
    }
  }

  /* ── Delivery estimate — computed in the browser so it can never go
     stale via page caching; lands on a weekday ── */
  function setDeliveryDate() {
    var el = document.getElementById('cz-delivery-date');
    if (!el) return;
    var d = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
    if (d.getDay() === 6) d.setDate(d.getDate() + 2);
    else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    try {
      el.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    } catch (e) { /* keep the server-rendered fallback */ }
  }

  /* ── Wire ── */
  function wire() {
    document.querySelectorAll('.cz__frame-tab').forEach(function (btn) {
      btn.addEventListener('click', function () { activateCar(btn); });
    });

    var drop  = document.getElementById('cz-drop');
    var input = document.getElementById('cz-file');

    drop.addEventListener('click', function (e) { if (!e.target.closest('#cz-remove')) input.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') input.click(); });
    drop.addEventListener('dragover',  function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    drop.addEventListener('dragleave', function ()  { drop.classList.remove('is-over'); });
    drop.addEventListener('drop', function (e) {
      e.preventDefault(); drop.classList.remove('is-over');
      if (e.dataTransfer.files[0]) { ownUpload(); loadLogo(e.dataTransfer.files[0]); }
    });
    input.addEventListener('change', function () { if (input.files[0]) { ownUpload(); loadLogo(input.files[0]); } });
    /* The logo maker hands over a finished PNG; from here it is an upload
       like any other. */
    document.addEventListener('md:logo-made', function (e) {
      state.logoBrief = e.detail.brief;
      state.logoRefUrl = e.detail.referenceUrl || null;
      loadLogo(e.detail.file);
    });
    document.getElementById('cz-remove').addEventListener('click', function (e) { e.stopPropagation(); clearLogo(); });

    document.querySelectorAll('input[name="cz-size"]').forEach(function (r) {
      r.addEventListener('change', function () {
        document.querySelectorAll('.cz__size').forEach(function (o) { o.classList.remove('is-selected'); });
        r.closest('.cz__size').classList.add('is-selected');
        state.size = r.value;
        refreshPanel();
        if (logo.img) placeLogo(true);
        scheduleCut();
        syncSummary();
        draw();
      });
    });

    document.querySelectorAll('input[name="cz-pack"]').forEach(function (r) {
      r.addEventListener('change', function () {
        document.querySelectorAll('.cz__pack-opt').forEach(function (o) { o.classList.remove('cz__pack-opt--active'); });
        r.closest('.cz__pack-opt').classList.add('cz__pack-opt--active');
        state.pack = r.value;
        syncSummary();
      });
    });

    document.querySelectorAll('.cz__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.cz__swatch').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.color     = btn.dataset.color;
        state.colorName = btn.dataset.name;
        if (state.color !== 'original' && state.bgDetected && !state.removeBg) setRemoveBg(true);
        if (logo.img) placeLogo(true);
        scheduleCut();
        syncSummary();
        draw();
      });
    });

    canvas.addEventListener('mousedown',  onPtrDown);
    canvas.addEventListener('mousemove',  onPtrMove);
    canvas.addEventListener('mouseup',    onPtrUp);
    canvas.addEventListener('mouseleave', onPtrUp);
    canvas.addEventListener('touchstart', onPtrDown, { passive: false });
    canvas.addEventListener('touchmove',  onPtrMove, { passive: false });
    canvas.addEventListener('touchend',   onPtrUp);

    var awareCheck = document.getElementById('cz-aware');
    if (awareCheck) {
      awareCheck.addEventListener('change', updateBuyState);
    }

    /* Keyboard equivalent of the pointer drag/resize/rotate interactions */
    canvas.addEventListener('keydown', function (e) {
      if (!logo.img) return;
      var step    = (e.shiftKey ? 5 : 1) * Math.max(2, canvas.width * 0.005);
      var ratio   = logo.h / logo.w;
      var handled = true;
      switch (e.key) {
        case 'ArrowLeft':  logo.cx -= step; break;
        case 'ArrowRight': logo.cx += step; break;
        case 'ArrowUp':    logo.cy -= step; break;
        case 'ArrowDown':  logo.cy += step; break;
        case '+': case '=': logo.w *= 1.05; logo.h = logo.w * ratio; break;
        case '-': case '_': logo.w = Math.max(30, logo.w * 0.95); logo.h = logo.w * ratio; break;
        case '[': logo.r -= Math.PI / 36; break;
        case ']': logo.r += Math.PI / 36; break;
        default: handled = false;
      }
      if (handled) { e.preventDefault(); clampLogo(); rememberLogo(); updateDims(); draw(); }
    });

    var bgBox = document.getElementById('cz-bg-remove');
    if (bgBox) bgBox.addEventListener('change', function () { setRemoveBg(bgBox.checked); });

    document.getElementById('cz-buy').addEventListener('click', placeOrder);
  }

  /* ── Car ── */
  function activateCar(btn) {
    document.querySelectorAll('.cz__frame-tab').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    state.car      = btn.dataset.car;
    state.carLabel = btn.dataset.label;
    syncSummary();
    loadCar(state.car, function () { if (logo.img) placeLogo(true); draw(); renderCutNote(); });
  }

  function loadCar(key, cb) {
    if (carCache[key]) {
      setupCanvas(carCache[key]);
      document.getElementById('cz-empty').hidden = true;
      draw(); if (cb) cb(); return;
    }
    var url = carUrls[key];
    if (!url) {
      setLoading(false);
      var emptyEl = document.getElementById('cz-empty');
      if (emptyEl) { emptyEl.hidden = false; emptyEl.querySelector('p').textContent = 'Car image not set. Open Theme Editor → Customize page → set car images.'; }
      if (cb) cb();
      return;
    }
    setLoading(true);
    /* crossOrigin keeps the canvas exportable for the order snapshot (Shopify
       CDN sends CORS headers); if that load fails, retry plain, the preview
       still works, only the snapshot upload gets skipped. */
    var attempt = function (useCors) {
      var img = new Image();
      if (useCors) img.crossOrigin = 'anonymous';
      img.onload = function () {
        carCache[key] = img;
        setupCanvas(img);
        setLoading(false);
        document.getElementById('cz-empty').hidden = true;
        setHint('Preview is illustrative. Final placement may vary slightly based on vehicle model and body shape.');
        draw();
        if (cb) cb();
      };
      img.onerror = function () {
        if (useCors) { attempt(false); return; }
        setLoading(false);
        var emptyEl = document.getElementById('cz-empty');
        if (emptyEl) { emptyEl.hidden = false; emptyEl.querySelector('p').textContent = 'Could not load car image: ' + url; }
      };
      img.src = url;
    };
    attempt(true);
  }

  function setupCanvas(img) {
    canvas.width  = img.naturalWidth;
    canvas.height = img.naturalHeight;
  }

  /* ── Cloudinary upload ── */
  function uploadToCloudinary(file, cb) {
    var cl = cfg.cloudinary || {};
    if (!cl.cloudName || !cl.preset) { if (cb) cb(null); return; }
    state.uploading = true;
    state.uploadFailed = false;
    state.uploadUrl = null;
    updateUploadStatus('uploading');
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', cl.preset);
    fetch('https://api.cloudinary.com/v1_1/' + cl.cloudName + '/auto/upload', {
      method: 'POST',
      body: fd
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      state.uploading = false;
      if (data.secure_url) {
        state.uploadUrl = data.secure_url;
        state.uploadFailed = false;
        updateUploadStatus('done');
      } else {
        state.uploadFailed = true;
        updateUploadStatus('error');
      }
      if (cb) cb(data.secure_url || null);
    })
    .catch(function () {
      state.uploading = false;
      state.uploadFailed = true;
      updateUploadStatus('error');
      if (cb) cb(null);
    });
  }

  function updateUploadStatus(st) {
    var el = document.getElementById('cz-upload-status');
    if (!el) return;
    el.className = 'cz__upload-status';
    if (st === 'uploading') { el.textContent = '⏳ Uploading file…'; el.classList.add('cz__upload-status--uploading'); }
    else if (st === 'done') { el.textContent = '✓ File saved';       el.classList.add('cz__upload-status--done'); }
    else if (st === 'error'){ el.textContent = '⚠ Upload failed';    el.classList.add('cz__upload-status--error'); }
    else { el.textContent = ''; }
    updateBuyState();
    if (saveApi) saveApi.refresh();
  }

  /* ── Order snapshot — what the customer sees is what staff sees ── */
  function uploadBlobToCloudinary(blob, name, cb) {
    var cl = cfg.cloudinary || {};
    if (!cl.cloudName || !cl.preset || !blob) return cb(null);
    var fd = new FormData();
    fd.append('file', blob, name);
    fd.append('upload_preset', cl.preset);
    fetch('https://api.cloudinary.com/v1_1/' + cl.cloudName + '/auto/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) { cb(data.secure_url || null); })
      .catch(function () { cb(null); });
  }

  function exportPreviewBlob(cb) {
    if (!logo.img || !carCache[state.car] || !canvas.width) return cb(null);
    var restore = function () { isExporting = false; try { draw(); } catch (e) {} };
    try {
      isExporting = true;
      draw();
      var scale = Math.min(1, 1200 / canvas.width);
      var out = document.createElement('canvas');
      out.width  = Math.max(1, Math.round(canvas.width * scale));
      out.height = Math.max(1, Math.round(canvas.height * scale));
      out.getContext('2d').drawImage(canvas, 0, 0, out.width, out.height);
      restore();
      out.toBlob(function (blob) { cb(blob); }, 'image/jpeg', 0.85);
    } catch (e) {
      /* tainted canvas (CORS-less car image) or export failure — skip snapshot */
      restore();
      cb(null);
    }
  }

  function buildPreviewUrl(cb) {
    var done  = false;
    var timer = setTimeout(function () { finish(null); }, 8000);
    function finish(url) { if (!done) { done = true; clearTimeout(timer); cb(url); } }
    exportPreviewBlob(function (blob) {
      if (!blob) return finish(null);
      uploadBlobToCloudinary(blob, 'preview.jpg', finish);
    });
  }

  /* ── Logo ── */
  function showFileErr(msg) {
    var el = document.getElementById('cz-file-err');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function showFilled(name, thumbSrc) {
    var thumb = document.getElementById('cz-thumb');
    /* No thumbnail until there is a real image: a PDF or SVG would show a
       broken icon with its alt text. */
    if (thumbSrc) { thumb.src = thumbSrc; thumb.hidden = false; }
    else { thumb.removeAttribute('src'); thumb.hidden = true; }
    document.getElementById('cz-fname').textContent  = name;
    document.getElementById('cz-drop-empty').hidden  = true;
    document.getElementById('cz-drop-filled').hidden = false;
  }

  /* Browsers cannot draw PDFs, and SVGs without a size come out 1x1, so
     both are rasterised by Cloudinary from the uploaded original. */
  function isVector(file) {
    return /pdf|svg/i.test(file.type || '') || /\.(pdf|svg)$/i.test(file.name || '');
  }

  function loadLogo(file) {
    showFileErr('');
    state.fix = { stage: 'idle' };
    if (isVector(file)) {
      showFilled(file.name);
      setHint('Preparing your file…');
      uploadToCloudinary(file, function (url) {
        if (url) loadLogoFromUrl(url, file.name, true);
        else showFileErr('We could not read this file. Please upload a PNG or JPG, or use “Having trouble with your design?”.');
      });
      return;
    }
    uploadToCloudinary(file);
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () { setLogoImage(img, e.target.result, file.name); };
      img.onerror = function () { showFileErr('We could not open this image. Please try a PNG or JPG file.'); };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  function loadLogoFromUrl(url, name, vector) {
    var src = vector ? url.replace('/upload/', '/upload/f_png,pg_1,w_2000/') : url;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { setLogoImage(img, src, name || 'Your logo'); };
    img.onerror = function () { showFileErr('We could not open your logo. Please upload it again.'); };
    img.src = src;
  }

  function setLogoImage(img, thumbSrc, name) {
    logo.img = img;
    logo.r = 0;
    logo.prepared = null;
    logo.preparedKey = '';
    state.bgDetected = !!MD.edgeBackground(MD.toCanvas(img, 600));
    /* Solid backgrounds come off on their own, as in the AI studio: the
       cut check then sees the real shape. "Yours" keeps the file as sent. */
    state.removeBg = state.bgDetected && state.fix.stage !== 'original' && state.fix.stage !== 'panel';
    var bgBox = document.getElementById('cz-bg-remove');
    if (bgBox) bgBox.checked = state.removeBg;
    state.cut = null;
    placeLogo(false);
    scheduleCut();
    showFilled(name, thumbSrc);
    document.getElementById('cz-empty').hidden = true;
    setHint('Drag to move · Corners to resize · Blue handle to rotate · It always stays inside the magnet');
    updateBgUi();
    draw();
    updateBuyState();
    if (saveApi) saveApi.refresh();
  }

  function setRemoveBg(on) {
    state.removeBg = !!on;
    var bgBox = document.getElementById('cz-bg-remove');
    if (bgBox) bgBox.checked = state.removeBg;
    if (logo.img) placeLogo(true);
    updateBgUi();
    scheduleCut();
    draw();
  }

  /* The logo exactly as it will be printed: background removed only when
     the customer asked for it, colour applied when one is chosen. */
  function baseArt() {
    var key = (state.removeBg ? 'nobg' : 'bg') + '|' + state.color;
    if (logo.preparedKey !== key || !logo.prepared) {
      logo.prepared = MD.prepareLogo(logo.img, { removeBg: state.removeBg, colour: state.color });
      logo.preparedKey = key;
    }
    return logo.prepared;
  }

  /* A logo that still can't be cut gets a white edge joining its pieces. */
  function prepared() {
    var base = baseArt();
    var cut = state.cut;
    if (!cut || !cut.edge) return base;
    var key = logo.preparedKey + '|' + cut.id;
    if (logo.cutKey !== key) {
      logo.cutArt = CUT.render(base, cut.inW, cut.edge, { maxPx: 2400 });
      logo.cutKey = key;
    }
    return logo.cutArt;
  }

  /* ── Cut check ──
     Runs at the logo's real printed width for the chosen plan. A logo the
     cutter can't handle (hairlines, specks, dozens of pieces) is redrawn
     by the AI under the logo maker's print rules and swapped in; if that
     fails, or the redraw still can't be cut, a white edge joins the pieces.
     The customer only sees one line about it. */
  var CUT = window.MDCut;
  var cutTimer = null, cutSeq = 0;

  function scheduleCut() {
    if (!CUT) return;
    clearTimeout(cutTimer);
    if (!logo.img) { state.cut = null; renderCutNote(); return; }
    state.cut = { busy: true, id: ++cutSeq };
    cutTimer = setTimeout(runCut, 60);
  }

  function runCut() {
    var c = state.cut;
    if (!c || !logo.img) return;
    var base = baseArt();
    c.inW = MD.fitInches(base.width, base.height, state.size).artW;
    c.report = CUT.analyze(base, c.inW);
    c.busy = false;
    c.edge = null;
    if (!c.report.ok) {
      if (state.fix.stage === 'idle') startFix(c.report);
      else if (state.fix.stage !== 'working') c.edge = CUT.variants(base, c.inW, c.report)[0];
    }
    logo.cutKey = '';
    if (logo.img) placeLogo(true);
    renderCutNote();
    draw();
  }

  function cutReason(r) {
    return r.pieces + ' pieces, ' + r.tiny + ' under ' + CUT.LIMITS.MIN_PIECE_IN + 'in, ' + r.thinSqIn + ' sq in thinner than ' + CUT.LIMITS.MIN_LINE_IN + 'in';
  }

  /* Waits for the upload to reach Cloudinary, since the server only works
     from files uploaded through the store. */
  function whenUploaded(cb, tries) {
    if (state.uploadUrl) return cb(state.uploadUrl);
    if (state.uploadFailed || (tries || 0) > 60) return cb(null);
    setTimeout(function () { whenUploaded(cb, (tries || 0) + 1); }, 500);
  }

  /* The art as it would be printed: background gone, and a white edge
     when it still has parts too small to cut. Used for the version tiles. */
  function finalArt(img, removeBg) {
    var art = MD.prepareLogo(img, { removeBg: removeBg, colour: 'original', max: 900 });
    var inW = MD.fitInches(art.width, art.height, state.size).artW;
    var r = CUT.analyze(art, inW);
    return r.ok ? art : CUT.render(art, inW, CUT.variants(art, inW, r)[0], { maxPx: 600 });
  }

  /* One piece: the customer's own logo on a white panel that fills the
     whole plan they picked. The cutter only follows the panel's outline,
     so any logo works and it is ready at once, without the AI. */
  var PANEL_PAD_IN = 1.5, PANEL_RADIUS_IN = 1;
  var AI_VERSIONS = [1, 2];

  function buildPanel(img, removeBg, px) {
    px = px || 2400;
    var art = MD.prepareLogo(img, { removeBg: removeBg, colour: 'original', max: Math.max(1600, px) });
    var wIn = MD.PLAN_WIDTH_IN[state.size] - MD.CUT_MARGIN_IN * 2;
    var hIn = MD.PLAN_HEIGHT_IN - MD.CUT_MARGIN_IN * 2;
    var ppi = px / wIn;
    var c = MD.makeCanvas(wIn * ppi, hIn * ppi), g = c.getContext('2d');
    var r = PANEL_RADIUS_IN * ppi;
    var fill = state.fix.panelColor || '#ffffff';
    g.fillStyle = fill;
    g.beginPath();
    g.moveTo(r, 0);
    g.arcTo(c.width, 0, c.width, c.height, r);
    g.arcTo(c.width, c.height, 0, c.height, r);
    g.arcTo(0, c.height, 0, 0, r);
    g.arcTo(0, 0, c.width, 0, r);
    g.closePath();
    g.fill();
    var bw = c.width - 2 * PANEL_PAD_IN * ppi, bh = c.height - 2 * PANEL_PAD_IN * ppi;
    var k = Math.min(bw / art.width, bh / art.height);
    if (fill !== '#ffffff') art = knockout(art, fill);
    g.drawImage(art, (c.width - art.width * k) / 2, (c.height - art.height * k) / 2, art.width * k, art.height * k);
    return c;
  }

  /* On a coloured panel, parts of the logo in that same colour would vanish,
     so they are printed white instead. */
  function knockout(art, hex) {
    var rgb = [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
    var c = MD.makeCanvas(art.width, art.height), g = c.getContext('2d');
    g.drawImage(art, 0, 0);
    var d = g.getImageData(0, 0, c.width, c.height), p = d.data;
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 10) continue;
      if (Math.abs(p[i] - rgb[0]) + Math.abs(p[i + 1] - rgb[1]) + Math.abs(p[i + 2] - rgb[2]) < 120) { p[i] = 255; p[i + 1] = 255; p[i + 2] = 255; }
    }
    g.putImageData(d, 0, 0);
    return c;
  }

  /* White, black and the logo's own strongest colours. */
  function panelColors(img) {
    var art = MD.prepareLogo(img, { removeBg: true, colour: 'original', max: 120 });
    var p = art.getContext('2d').getImageData(0, 0, art.width, art.height).data, bins = {};
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 200) continue;
      var mx = Math.max(p[i], p[i + 1], p[i + 2]), mn = Math.min(p[i], p[i + 1], p[i + 2]);
      if (!mx || (mx - mn) / mx < 0.3) continue;
      var key = (p[i] >> 5) + ',' + (p[i + 1] >> 5) + ',' + (p[i + 2] >> 5);
      var e = bins[key] || (bins[key] = { n: 0, r: 0, g: 0, b: 0 });
      e.n++; e.r += p[i]; e.g += p[i + 1]; e.b += p[i + 2];
    }
    var brand = [];
    Object.keys(bins).map(function (k) { return bins[k]; })
      .sort(function (a, b) { return b.n - a.n; })
      .forEach(function (e) {
        var c = [e.r / e.n, e.g / e.n, e.b / e.n];
        var near = brand.some(function (o) { return Math.abs(o[0] - c[0]) + Math.abs(o[1] - c[1]) + Math.abs(o[2] - c[2]) < 90; });
        if (!near && brand.length < 2) brand.push(c);
      });
    return ['#ffffff', '#111111'].concat(brand.map(function (c) {
      return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join('');
    }));
  }

  function setPanelColor(hex) {
    state.fix.panelColor = hex;
    refreshPanel();
    if (logo.img) placeLogo(true);
    draw();
    renderCutNote();
  }

  function startFix(report) {
    var fx = state.fix = {
      stage: 'working',
      name: (document.getElementById('cz-fname') || {}).textContent || 'Your logo',
      versions: [], pending: AI_VERSIONS.length, chosen: null,
      originalImg: logo.img, originalBg: state.removeBg, panelColor: '#ffffff'
    };
    fx.panelColors = panelColors(logo.img);
    fx.originalThumb = finalArt(logo.img, false);
    chooseVersion('panel');
    whenUploaded(function (url) {
      if (state.fix !== fx) return;
      if (!url) { fx.pending = 0; renderCutNote(); return; }
      fx.originalUrl = url;
      CUT.fixVersions({
        api: cfg.cutApi, sitekey: cfg.cutSitekey, logoUrl: url, reason: cutReason(report), versions: AI_VERSIONS,
        colors: CUT.logoColors(fx.originalImg),
        onResult: function (i, fixed) {
          if (state.fix !== fx) return;
          if (!fixed) { fx.pending--; renderCutNote(); return; }
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            if (state.fix !== fx) return;
            fx.pending--;
            fx.versions[i] = { url: fixed, thumb: finalArt(img, true) };
            renderCutNote();
          };
          img.onerror = function () { fx.pending--; renderCutNote(); };
          img.src = fixed;
        }
      }).then(function () {
        if (state.fix !== fx) return;
        fx.pending = 0;
        renderCutNote();
      });
    });
  }

  /* key: 'panel', an AI version index, or -1 for the customer's own file. */
  function chooseVersion(key) {
    var fx = state.fix;
    if (key === fx.chosen) return;
    fx.chosen = key;
    if (key === 'panel') {
      fx.stage = 'panel';
      var panel = buildPanel(fx.originalImg, fx.originalBg);
      setLogoImage(panel, panel.toDataURL('image/png'), fx.name);
    } else if (key < 0) {
      fx.stage = 'original';
      if (fx.originalUrl) { state.uploadUrl = fx.originalUrl; loadLogoFromUrl(fx.originalUrl, fx.name); }
      else setLogoImage(fx.originalImg, fx.originalThumb.toDataURL('image/png'), fx.name);
    } else {
      fx.stage = 'done';
      state.uploadUrl = fx.versions[key].url;
      loadLogoFromUrl(fx.versions[key].url, fx.name);
    }
    renderCutNote();
  }

  /* The panel follows the plan: a new size means a new panel shape. */
  function refreshPanel() {
    var fx = state.fix;
    if (fx.stage !== 'panel' || !fx.originalImg) return;
    logo.img = buildPanel(fx.originalImg, fx.originalBg);
    logo.prepared = null;
    logo.preparedKey = '';
  }

  function renderCutNote() {
    var el = document.getElementById('cz-cut-note');
    var box = document.getElementById('cz-fix');
    if (!el || !box) return;
    var fx = state.fix, c = state.cut;
    var picking = !!fx.versions && (fx.stage === 'working' || fx.stage === 'panel' || fx.stage === 'done' || fx.stage === 'original');
    var text = '';
    if (!logo.img) text = '';
    else if (picking) text = 'Pick your favorite.';
    else if (c && c.edge) text = 'We added a white edge so your magnet is one solid piece.';
    el.classList.remove('is-busy');
    el.hidden = !text;
    el.textContent = text;

    box.innerHTML = '';
    box.hidden = !(logo.img && picking);
    var pc = document.getElementById('cz-panel-colors');
    if (pc && box.hidden) pc.hidden = true;
    if (box.hidden) return;
    addFixTile(box, 'panel', { thumb: buildPanel(fx.originalImg, fx.originalBg, 900) },
      { name: 'One piece', sub: 'Your logo on a panel the full size of your magnet' }, false);
    AI_VERSIONS.forEach(function (i) { addFixTile(box, i, fx.versions[i], CUT.FIX_NAMES[i], fx.pending > 0); });
    addFixTile(box, -1, { thumb: fx.originalThumb }, { name: 'Your original', sub: 'Exactly as you uploaded it' }, false);

    var colors = document.getElementById('cz-panel-colors');
    if (!colors) return;
    colors.hidden = fx.stage !== 'panel';
    colors.innerHTML = '';
    if (colors.hidden) return;
    var label = document.createElement('span');
    label.textContent = 'Panel colour';
    colors.appendChild(label);
    fx.panelColors.forEach(function (hex) {
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'cz__panel-swatch';
      sw.style.background = hex;
      sw.setAttribute('role', 'radio');
      sw.setAttribute('aria-label', hex === '#ffffff' ? 'White' : hex === '#111111' ? 'Black' : 'Logo colour ' + hex);
      sw.setAttribute('aria-checked', String(fx.panelColor === hex));
      sw.addEventListener('click', function () { setPanelColor(hex); });
      colors.appendChild(sw);
    });
  }

  /* The version on the customer's own car and plan, cropped around the door. */
  function carPreview(art) {
    var carImg = carCache[state.car];
    var out = MD.makeCanvas(640, 480), g = out.getContext('2d');
    if (!carImg || !canvas.width) {
      var k0 = Math.min(600 / art.width, 440 / art.height);
      g.drawImage(art, (640 - art.width * k0) / 2, (480 - art.height * k0) / 2, art.width * k0, art.height * k0);
      return out;
    }
    var box = getBox(state.size);
    var k = fitScale(box, art);
    var cw = Math.min(canvas.width, box.w * 1.6), ch = Math.min(canvas.height, cw * 0.75);
    cw = ch / 0.75;
    var sx = Math.max(0, Math.min(canvas.width - cw, box.x + box.w / 2 - cw / 2));
    var sy = Math.max(0, Math.min(canvas.height - ch, box.y + box.h / 2 - ch / 2));
    var s = 640 / cw;
    g.drawImage(carImg, sx, sy, cw, ch, 0, 0, 640, 480);
    var w = art.width * k * s, h = art.height * k * s;
    var cx = (box.x + box.w / 2 - sx) * s, cy = (box.y + box.h / 2 - sy) * s;
    g.save();
    g.shadowColor = 'rgba(0,0,0,0.18)';
    g.shadowBlur = 8;
    g.shadowOffsetY = 3;
    g.drawImage(art, cx - w / 2, cy - h / 2, w, h);
    g.restore();
    return out;
  }

  function addFixTile(box, i, v, meta, waiting) {
    var fx = state.fix;
    if (!v && !waiting) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cz__fix-card' + (v ? '' : ' is-loading');
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', String(fx.chosen === i));
    b.disabled = !v;
    var cv = document.createElement('canvas');
    cv.width = 640; cv.height = 480;
    b.appendChild(cv);
    var check = document.createElement('span');
    check.className = 'cz__fix-check';
    check.textContent = '✓';
    b.appendChild(check);
    b.setAttribute('aria-label', meta.name);
    if (v) {
      cv.getContext('2d').drawImage(carPreview(v.thumb), 0, 0);
      b.addEventListener('click', function () { chooseVersion(i); });
    }
    box.appendChild(b);
  }

  function cutLabel() {
    if (state.fix.stage === 'panel') return 'One piece · full-size panel';
    return state.cut && state.cut.edge ? 'One piece · white edge' : 'Fully die-cut';
  }

  function cutSummary() {
    var c = state.cut, fx = state.fix;
    if (fx.stage === 'panel') return 'Logo had parts too small to cut · customer chose the full-size panel';
    if (!c || !c.report) return '';
    var r = c.report;
    var parts = [r.ok ? 'Cuts cleanly (' + r.pieces + (r.pieces === 1 ? ' piece)' : ' pieces)') : 'Cut problems: ' + cutReason(r)];
    if (fx.stage === 'done') parts.push('logo redrawn by AI for cutting: ' + CUT.FIX_NAMES[fx.chosen].name);
    if (fx.stage === 'original') parts.push('customer kept the original');
    if (c.edge) parts.push('white edge added, 1 piece');
    return parts.join(' · ');
  }

  function paintThumb(id, source) {
    var c = document.getElementById(id);
    if (!c || !source) return;
    var g = c.getContext('2d');
    g.clearRect(0, 0, c.width, c.height);
    var w = source.width || source.naturalWidth, h = source.height || source.naturalHeight;
    var k = Math.min((c.width - 16) / w, (c.height - 16) / h);
    g.drawImage(source, (c.width - w * k) / 2, (c.height - h * k) / 2, w * k, h * k);
  }

  function updateBgUi() {
    var wrap = document.getElementById('cz-bg');
    if (!wrap) return;
    wrap.hidden = !(logo.img && state.bgDetected) || state.fix.stage === 'done';
    if (wrap.hidden) return;
    paintThumb('cz-bg-before', logo.img);
    paintThumb('cz-bg-after', baseArt());
  }

  function ownUpload() {
    if (!state.logoBrief) return;
    state.logoBrief = null; state.logoRefUrl = null;
    document.dispatchEvent(new CustomEvent('md:logo-cleared'));
  }

  function clearLogo() {
    ownUpload();
    logo.img = null; logo.prepared = null; logo.preparedKey = '';
    logo.ox = 0; logo.oy = 0; logo.k = 1;
    state.uploadUrl = null; state.uploading = false; state.uploadFailed = false;
    state.bgDetected = false; state.removeBg = false;
    state.cut = null; state.fix = { stage: 'idle' }; renderCutNote();
    document.getElementById('cz-file').value             = '';
    document.getElementById('cz-drop-empty').hidden      = false;
    document.getElementById('cz-drop-filled').hidden     = true;
    /* #cz-empty is the "no car selected" placeholder, not a "no logo" one, and
       it sits in normal flow above the canvas. Showing it while a car is
       loaded injects a block that shoves the canvas down inside the sticky
       studio, which wrecks the layout on mobile. Only show it with no car. */
    var emptyEl = document.getElementById('cz-empty');
    if (emptyEl) emptyEl.hidden = !!(state.car && carCache[state.car]);
    showFileErr('');
    updateUploadStatus('');
    updateBgUi();
    updateDims();
    setHint('Preview is illustrative. Final placement may vary slightly based on vehicle model and body shape.');
    draw();
    updateBuyState();
    if (saveApi) saveApi.refresh();
  }

  /* keep: re-fit after a change of car, size or background while keeping
     the customer's position, scale and rotation. */
  function placeLogo(keep) {
    if (!logo.img || !canvas.width) return;
    var box = getBox(state.size);
    var art = prepared();
    var fitK = fitScale(box, art);
    var k = keep ? (logo.k || 1) : 1;
    if (!keep) { logo.r = 0; logo.ox = 0; logo.oy = 0; logo.k = 1; }
    logo.w = art.width * fitK * k;
    logo.h = art.height * fitK * k;
    logo.cx = box.x + box.w / 2 + (logo.ox || 0) * box.ppi;
    logo.cy = box.y + box.h / 2 + (logo.oy || 0) * box.ppi;
    clampLogo();
    rememberLogo();
    updateDims();
  }

  function fitScale(box, art) {
    var m = MD.CUT_MARGIN_IN * box.ppi;
    return Math.min((box.w - 2 * m) / art.width, (box.h - 2 * m) / art.height);
  }

  /* Keep the whole (rotated) logo inside the magnet's maximum area. */
  function clampLogo() {
    if (!logo.img) return;
    var box = getBox(state.size);
    var m = MD.CUT_MARGIN_IN * box.ppi;
    var c = Math.abs(Math.cos(logo.r)), sn = Math.abs(Math.sin(logo.r));
    var ex = (logo.w * c + logo.h * sn) / 2;
    var ey = (logo.w * sn + logo.h * c) / 2;
    var maxX = box.w / 2 - m, maxY = box.h / 2 - m;
    var f = Math.min(1, maxX / ex, maxY / ey);
    if (f < 1) { logo.w *= f; logo.h *= f; ex *= f; ey *= f; }
    var cx0 = box.x + box.w / 2, cy0 = box.y + box.h / 2;
    logo.cx = Math.max(cx0 - (maxX - ex), Math.min(cx0 + (maxX - ex), logo.cx));
    logo.cy = Math.max(cy0 - (maxY - ey), Math.min(cy0 + (maxY - ey), logo.cy));
  }

  function rememberLogo() {
    if (!logo.img) return;
    var box = getBox(state.size);
    var art = prepared();
    logo.k  = (logo.w / art.width) / fitScale(box, art);
    logo.ox = (logo.cx - (box.x + box.w / 2)) / box.ppi;
    logo.oy = (logo.cy - (box.y + box.h / 2)) / box.ppi;
  }

  /* Real size of the finished magnet: artwork plus the cut margin. */
  function currentInches() {
    if (!logo.img || !canvas.width) return null;
    var box = getBox(state.size);
    var c = Math.abs(Math.cos(logo.r)), sn = Math.abs(Math.sin(logo.r));
    var w = (logo.w * c + logo.h * sn) / box.ppi + MD.CUT_MARGIN_IN * 2;
    var h = (logo.w * sn + logo.h * c) / box.ppi + MD.CUT_MARGIN_IN * 2;
    return { w: Math.round(w), h: Math.round(h) };
  }

  function updateDims() {
    var el = document.getElementById('cz-dims');
    var note = document.getElementById('cz-size-note');
    var inch = currentInches();
    if (el) {
      el.hidden = !inch;
      if (inch) el.innerHTML = 'Your magnet: <strong>' + inch.w + '″ × ' + inch.h + '″</strong> · ' + PLAN_NAMES[state.size] + ' fits up to ' + MD.PLAN_WIDTH_IN[state.size] + '″ × ' + MD.PLAN_HEIGHT_IN + '″';
    }
    if (note) {
      var same = logo.img ? MD.samePlans(prepared().width, prepared().height) : [];
      var startIn = logo.img ? MD.fitInches(prepared().width, prepared().height, 'small') : null;
      if (same.length && startIn) {
        var names = same.map(function (p) { return PLAN_NAMES[p]; }).join(' and ');
        note.textContent = 'With your logo, ' + names + ' come out the same size as Starter (' + Math.round(startIn.w) + '″ × ' + Math.round(startIn.h) + '″). Starter is the best value.';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  /* ── Zone ── */
  function getBox(sizeKey) {
    /* Centre comes from the theme settings per car; size comes from real
       inches, so every plan is drawn to the vehicle's true scale. */
    var cz  = zones[state.car] || { cx: .47, cy: .55 };
    var ppi = MD.ppi(state.car, canvas.width);
    var bw  = (MD.PLAN_WIDTH_IN[sizeKey] || 35) * ppi;
    var bh  = MD.PLAN_HEIGHT_IN * ppi;
    return { x: cz.cx * canvas.width - bw / 2, y: cz.cy * canvas.height - bh / 2, w: bw, h: bh, ppi: ppi };
  }

  /* ── Draw ── */
  function draw() {
    var carImg = carCache[state.car];
    if (!carImg) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(carImg, 0, 0, canvas.width, canvas.height);

    if (!logo.img) { drawCalibBoxes(); return; }

    var box = getBox(state.size);

    /* Magnet outline and its maximum size; hidden in the order snapshot */
    if (!isExporting) {
      var lw = Math.max(1.5, canvas.width * 0.0018);
      ctx.save();
      ctx.setLineDash([lw * 5, lw * 3.5]);
      ctx.strokeStyle = 'rgba(246,182,41,0.95)';
      ctx.lineWidth   = lw;
      ctx.strokeRect(box.x, box.y, box.w, box.h);
      ctx.restore();
    }
    /* On phones the label would sit under the resize handles; the size pill
       below the canvas already says the same thing there. */
    if (!isExporting && canvas.clientWidth >= 500) {
      ctx.save();
      var fs = Math.max(14, canvas.width * 0.017);
      var label = 'Max ' + MD.PLAN_WIDTH_IN[state.size] + '″ × ' + MD.PLAN_HEIGHT_IN + '″';
      ctx.font = '600 ' + fs + 'px -apple-system,BlinkMacSystemFont,sans-serif';
      var tw = ctx.measureText(label).width, pad = fs * 0.45;
      ctx.fillStyle = 'rgba(35,37,39,0.85)';
      ctx.fillRect(box.x, box.y - fs - pad * 2, tw + pad * 2, fs + pad * 2);
      ctx.fillStyle = '#fff';
      ctx.textBaseline = 'middle';
      ctx.fillText(label, box.x + pad, box.y - (fs + pad * 2) / 2);
      ctx.restore();
    }

    /* The prepared logo is processed once per background/colour choice,
       so dragging only redraws it. Nothing near-white is erased: white
       letters and shapes inside the logo are part of the print. */
    var art = prepared();
    ctx.save();
    ctx.translate(logo.cx, logo.cy);
    ctx.rotate(logo.r);
    ctx.shadowColor   = 'rgba(0,0,0,0.18)';
    ctx.shadowBlur    = Math.max(6, logo.w * 0.025);
    ctx.shadowOffsetY = logo.w * 0.01;
    ctx.drawImage(art, -logo.w/2, -logo.h/2, logo.w, logo.h);
    ctx.restore();

    if (!isExporting) drawHandles();
  }

  function drawCalibBoxes() {
    var defs = [
      { key:'small',  color:'rgba(0,0,0,0.3)',  label:'35″×23″ Starter'  },
      { key:'medium', color:'rgba(0,0,0,0.3)',  label:'55″×23″ Standard' },
      { key:'large',  color:'rgba(0,0,0,0.3)',  label:'75″×23″ Large'    }
    ];
    var lw  = Math.max(1.5, canvas.width * 0.002);
    var fs  = Math.max(11, canvas.width * 0.012);
    var pad = fs * 0.45;
    var rowH = fs + pad + 6;
    ctx.font = '600 ' + fs + 'px -apple-system,sans-serif';
    ctx.textBaseline = 'middle';

    /* Draw box outlines first */
    defs.forEach(function (d) {
      var b = getBox(d.key);
      ctx.save();
      ctx.setLineDash([8, 5]);
      ctx.strokeStyle = 'rgba(0,0,0,0.25)';
      ctx.lineWidth   = lw;
      ctx.strokeRect(b.x, b.y, b.w, b.h);
      ctx.restore();
    });

    /* Draw labels stacked vertically in the center, offset so they don't overlap */
    var midBox  = getBox('medium');
    var centerX = midBox.x + midBox.w / 2;
    var centerY = midBox.y + midBox.h / 2;
    var totalH  = rowH * defs.length;
    var startY  = centerY - totalH / 2 + rowH / 2;

    defs.forEach(function (d, i) {
      var tw = ctx.measureText(d.label).width;
      var px = centerX - tw / 2 - pad;
      var py = startY + i * rowH - (fs + pad) / 2;
      ctx.save();
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(0,0,0,0.5)';
      ctx.beginPath();
      ctx.roundRect(px, py, tw + pad * 2, fs + pad, (fs + pad) / 2);
      ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.fillText(d.label, px + pad, py + (fs + pad) / 2);
      ctx.restore();
    });
  }

  /* ── Handles ── */
  function hs() { var r=canvas.getBoundingClientRect(); return r.width>0?canvas.width/r.width:1; }
  function rod() { return Math.round(38 * hs()); }
  function hitR() { return Math.round(11 * hs()); }

  function drawHandles() {
    if (!logo.img) return;
    var sc  = hs();
    var hr  = Math.round(6.5 * sc);
    var lw  = Math.round(1.5 * sc);
    var rd  = rod();
    var hw  = logo.w / 2;
    var hh  = logo.h / 2;

    ctx.save();
    ctx.translate(logo.cx, logo.cy);
    ctx.rotate(logo.r);

    ctx.setLineDash([Math.round(5*sc), Math.round(3*sc)]);
    ctx.strokeStyle = 'rgba(0,0,0,0.35)';
    ctx.lineWidth   = lw;
    ctx.strokeRect(-hw, -hh, logo.w, logo.h);
    ctx.setLineDash([]);

    ctx.beginPath();
    ctx.moveTo(0, -hh);
    ctx.lineTo(0, -hh - rd);
    ctx.strokeStyle = 'rgba(0,0,0,0.25)';
    ctx.lineWidth   = lw;
    ctx.stroke();

    [[-hw,-hh],[hw,-hh],[hw,hh],[-hw,hh]].forEach(function (c) {
      ctx.beginPath();
      ctx.arc(c[0], c[1], hr, 0, Math.PI*2);
      ctx.fillStyle   = '#fff';
      ctx.shadowColor = 'rgba(0,0,0,0.25)';
      ctx.shadowBlur  = hr;
      ctx.fill();
      ctx.shadowBlur  = 0;
      ctx.strokeStyle = 'rgba(0,0,0,0.2)';
      ctx.lineWidth   = Math.round(sc);
      ctx.stroke();
    });

    ctx.beginPath();
    ctx.arc(0, -hh - rd, hr, 0, Math.PI*2);
    ctx.fillStyle   = '#2563eb';
    ctx.shadowColor = 'rgba(37,99,235,0.35)';
    ctx.shadowBlur  = hr * 1.5;
    ctx.fill();
    ctx.shadowBlur  = 0;
    ctx.strokeStyle = '#1d4ed8';
    ctx.lineWidth   = Math.round(sc);
    ctx.stroke();

    ctx.restore();
  }

  /* ── Hit test ── */
  function hitTest(px, py) {
    if (!logo.img) return null;
    var hr  = hitR();
    var hw  = logo.w/2; var hh = logo.h/2; var rd = rod();
    var cos = Math.cos(-logo.r); var sin = Math.sin(-logo.r);
    var dx  = px-logo.cx; var dy = py-logo.cy;
    var lx  = dx*cos - dy*sin; var ly = dx*sin + dy*cos;
    if (Math.hypot(lx, ly+hh+rd) < hr) return 'rot';
    if (Math.hypot(lx+hw, ly+hh) < hr) return 'tl';
    if (Math.hypot(lx-hw, ly+hh) < hr) return 'tr';
    if (Math.hypot(lx-hw, ly-hh) < hr) return 'br';
    if (Math.hypot(lx+hw, ly-hh) < hr) return 'bl';
    if (Math.abs(lx)<=hw && Math.abs(ly)<=hh) return 'move';
    return null;
  }

  function toCanvas(e) {
    var r=canvas.getBoundingClientRect(); var sx=canvas.width/r.width; var sy=canvas.height/r.height;
    var src=e.touches?e.touches[0]:e;
    return { x:(src.clientX-r.left)*sx, y:(src.clientY-r.top)*sy };
  }

  /* ── Pointer ── */
  function onPtrDown(e) {
    if (!logo.img) return;
    var p=toCanvas(e); var h=hitTest(p.x,p.y);
    if (!h) return;
    e.preventDefault();
    drag.on=true; drag.handle=h; drag.sx=p.x; drag.sy=p.y;
    drag.ox=logo.cx; drag.oy=logo.cy; drag.ow=logo.w; drag.oh=logo.h; drag.or=logo.r;
    drag.sa=Math.atan2(p.y-logo.cy, p.x-logo.cx);
    drag.sd=Math.hypot(p.x-logo.cx, p.y-logo.cy);
  }

  function onPtrMove(e) {
    if (!logo.img) return;
    var p=toCanvas(e);
    if (!drag.on) {
      var h=hitTest(p.x,p.y);
      canvas.style.cursor=h?({move:'grab',rot:'crosshair',tl:'nw-resize',tr:'ne-resize',br:'se-resize',bl:'sw-resize'}[h]||'default'):'default';
      return;
    }
    e.preventDefault();
    if (drag.handle==='move') {
      logo.cx=drag.ox+(p.x-drag.sx); logo.cy=drag.oy+(p.y-drag.sy);
    } else if (drag.handle==='rot') {
      logo.r=drag.or+(Math.atan2(p.y-logo.cy, p.x-logo.cx)-drag.sa);
    } else {
      var d=Math.hypot(p.x-drag.ox, p.y-drag.oy);
      if (drag.sd>1) { logo.w=Math.max(30,drag.ow*(d/drag.sd)); logo.h=logo.w*(drag.oh/drag.ow); }
    }
    clampLogo();
    rememberLogo();
    updateDims();
    draw();
  }

  function onPtrUp() { if (drag.on) { drag.on=false; canvas.style.cursor='default'; } }

  /* ── Place order — add to cart then go straight to checkout ── */
  function placeOrder() {
    var vkey  = state.size + '_' + state.pack;
    var vid   = parseInt(variants[vkey]);
    var errEl = document.getElementById('cz-buy-err');
    if (errEl) { errEl.hidden = true; errEl.textContent = 'Something went wrong. Please try again.'; }

    /* Defense in depth — the button should already be disabled for any of these */
    var reason = buyBlockReason();
    if (reason) {
      if (errEl) { errEl.textContent = reason; errEl.hidden = false; }
      updateBuyState();
      return;
    }

    if (!vid) {
      if (errEl) { errEl.textContent = 'This size and pack combination is temporarily unavailable. Please contact us and we’ll sort it out.'; errEl.hidden = false; }
      return;
    }

    var notes    = (document.getElementById('cz-notes') || {}).value || '';
    var priceKey = state.pack === 'double' ? state.size + '_double' : state.size;
    var inch     = currentInches();
    /* Same names in all three editors. Files carry a leading underscore so
       they stay out of the customer's emails; the packing slip and staff
       notices show them explicitly. */
    var props    = {
      'Plan':  PLAN_NAMES[state.size],
      'Pack':  PACK_NAMES[state.pack],
      'Size':  'Up to ' + SIZE_DIMS[state.size][0] + '″ × ' + SIZE_DIMS[state.size][1] + '″',
      'Magnet size': inch ? inch.w + '″ × ' + inch.h + '″ (approx.)' : '',
      'Cut style': cutLabel(),
      'Vehicle': state.carLabel || state.car || 'Not selected',
      'Logo color': state.colorName,
      'Price': '$' + (prices[priceKey] || '0'),
      '_Editor': state.fallback ? 'classic (AI fallback)' : 'classic'
    };
    if (state.bgDetected) props['Background removed'] = state.removeBg ? 'Yes' : 'No';
    var cutInfo = cutSummary();
    if (cutInfo) props['_Cut check'] = cutInfo;
    if (state.fix.stage === 'done') { props['Logo'] = 'Adjusted for cutting'; props['_Original logo'] = state.fix.originalUrl; }
    if (state.fix.stage === 'panel') { props['Logo'] = 'On a full-size panel'; props['Panel colour'] = state.fix.panelColor; props['_Original logo'] = state.fix.originalUrl || state.uploadUrl; }
    if (notes.trim()) props['Special Instructions'] = notes.trim();

    setBuyLoading(true);

    /* Attach a snapshot of the live preview and, when the background was
       removed, the processed print file; neither ever blocks the sale. */
    buildPrintUrl(function (printUrl) {
    if (printUrl) { props['_Logo file'] = printUrl; props['_Original logo'] = props['_Original logo'] || state.uploadUrl; }
    else if (state.uploadUrl) props['_Logo file'] = state.uploadUrl;
    if (state.logoBrief) {
      var lb = state.logoBrief;
      props['Logo'] = 'Created with AI';
      props['_Logo brief'] = [lb.name, lb.line, lb.about, lb.type, lb.design, lb.style, lb.colors].filter(Boolean).join(' · ');
      if (state.logoRefUrl) props['_Logo reference'] = state.logoRefUrl;
    }
    buildPreviewUrl(function (previewUrl) {
    if (previewUrl) props['_Mockup'] = previewUrl;
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        });
      }
      /* /discount/<code>?redirect=… is Shopify's documented discount-link
         format: it applies the code and lands on checkout, so the customer
         never types it in. The AI studio applies the same code the same
         way, which keeps the two editors comparable in the A/B test. */
      var code = cfg.discountCode || '';
      window.location.href = code
        ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
        : '/checkout';
    })
    .catch(function (err) {
      setBuyLoading(false);
      if (errEl) {
        if (err && err.message && err.message !== 'Could not add to cart') errEl.textContent = err.message;
        errEl.hidden = false;
      }
    });
    });
    });
  }

  /* Print file uploaded next to the original: background removed and, when
     a cut-ready version was chosen, the edge the cutter follows. */
  function buildPrintUrl(cb) {
    var withEdge = !!(state.cut && state.cut.edge);
    var panel = state.fix.stage === 'panel';
    if ((!state.removeBg && !withEdge && !panel) || !logo.img) return cb(null);
    var done = false;
    var timer = setTimeout(function () { finish(null); }, 10000);
    function finish(url) { if (!done) { done = true; clearTimeout(timer); cb(url); } }
    try {
      var c = panel
        ? buildPanel(state.fix.originalImg, state.fix.originalBg, 6000)
        : MD.prepareLogo(logo.img, { removeBg: state.removeBg, colour: 'original', max: 4000 });
      if (withEdge && !panel) c = CUT.render(c, state.cut.inW, state.cut.edge, { maxPx: 6000 });
      c.toBlob(function (blob) {
        if (!blob) return finish(null);
        uploadBlobToCloudinary(blob, panel ? 'logo-panel.png' : withEdge ? 'logo-cut-ready.png' : 'logo-no-background.png', finish);
      }, 'image/png');
    } catch (e) { finish(null); }
  }

  /* Link that reopens this exact design: logo, car, size and pack. */
  function restoreUrl() {
    if (!state.uploadUrl) return '';
    var q = 'logo=' + encodeURIComponent(state.uploadUrl) +
            '&car=' + encodeURIComponent(state.car || '') +
            '&size=' + state.size + '&pack=' + state.pack;
    return window.location.origin + window.location.pathname + '?' + q;
  }

  /* ?logo=…&car=…&size=…&pack=… reopens a design (from an email, or from
     the AI studio when its photos fail; from=ai shows the notice). */
  function applyFallbackParams() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var url = q.get('logo');
    if (!url || url.indexOf('https://res.cloudinary.com/') !== 0) return;
    state.fallback = q.get('from') === 'ai';
    var car = q.get('car');
    var tab = car && document.querySelector('.cz__frame-tab[data-car="' + car + '"]');
    if (tab) activateCar(tab);
    ['size', 'pack'].forEach(function (k) {
      var v = q.get(k);
      var r = v && document.querySelector('input[name="cz-' + k + '"][value="' + v + '"]');
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    state.uploadUrl = url;
    updateUploadStatus('done');
    var vector = /\.(pdf|svg)(\?|$)/i.test(url);
    loadLogoFromUrl(url, 'Your logo', vector);
    var fb = document.getElementById('cz-fallback');
    if (fb && state.fallback) {
      fb.hidden = false;
      var retry = document.getElementById('cz-fallback-retry');
      var back = q.get('back');
      if (retry) {
        if (back && back.charAt(0) === '/') retry.href = back; else retry.hidden = true;
      }
    }
  }

  function mountSave() {
    if (!window.MDSaveDesign) return;
    saveApi = window.MDSaveDesign.mount({
      root: document.getElementById('cz-save'),
      previewRoot: document.getElementById('cz-save-quick'),
      canPrompt: function () { return !!(logo.img && state.uploadUrl); },
      getDesign: function (cb) {
        buildPreviewUrl(function (previewUrl) {
          cb({
            mockupUrl: previewUrl || '',
            restoreUrl: restoreUrl(),
            plan: PLAN_NAMES[state.size] + ' · ' + PACK_NAMES[state.pack],
            cutLabel: 'Fully die-cut',
            carType: state.carLabel || '',
            editor: 'classic'
          });
        });
      }
    });
  }

  function setBuyLoading(on) {
    var btn = document.getElementById('cz-buy');
    if (!btn) return;
    btn.disabled  = on;
    btn.style.opacity = on ? '0.7' : '';
  }

  /* ── Helpers ── */
  function setLoading(on) { var el=document.getElementById('cz-loading'); if(el) el.hidden=!on; }
  function setHint(t) { var el=document.getElementById('cz-hint'); if(el) el.textContent=t; }

  function syncSummary() {
    var ss = document.getElementById('cz-sum-size');
    if (ss) ss.textContent = SIZE_NAMES[state.size];

    var sp = document.getElementById('cz-sum-pack');
    if (sp) sp.textContent = PACK_NAMES[state.pack];

    var dot = document.getElementById('cz-sum-dot');
    var sc  = document.getElementById('cz-sum-color');
    if (dot) dot.style.background = state.color;
    if (sc)  sc.lastChild.textContent = ' ' + state.colorName;
    var cn = document.getElementById('cz-color-name');
    if (cn) cn.textContent = state.colorName;

    var priceKey  = state.pack === 'double' ? state.size + '_double' : state.size;
    var price     = prices[priceKey];
    var pv        = document.getElementById('cz-price');
    if (pv) pv.textContent = price ? '$' + price : '';

    var wasEl = document.getElementById('cz-price-was');
    if (wasEl) {
      if (state.pack === 'double') {
        var fullPrice = (prices[state.size] || 0) * 2;
        wasEl.textContent = '$' + fullPrice;
        wasEl.hidden = false;
      } else {
        wasEl.hidden = true;
      }
    }

    /* Update pack option prices */
    var ps  = document.getElementById('cz-pack-price-single');
    var pd  = document.getElementById('cz-pack-price-double');
    if (ps) ps.querySelector('span').textContent = prices[state.size] || '0';
    if (pd) pd.querySelector('span').textContent = prices[state.size + '_double'] || '0';
  }

  /* ── Mobile bottom sheet ── */
  var sheetHandle = document.getElementById('cz-sheet-handle');
  var panelEl     = document.getElementById('cz-panel');
  if (sheetHandle && panelEl) {
    sheetHandle.addEventListener('click', function () {
      panelEl.classList.toggle('is-open');
    });
    /* Close sheet when tapping the canvas on mobile */
    document.addEventListener('click', function (e) {
      if (panelEl.classList.contains('is-open') && !panelEl.contains(e.target)) {
        panelEl.classList.remove('is-open');
      }
    });
  }

  if (document.readyState==='loading') { document.addEventListener('DOMContentLoaded',init); } else { init(); }

})();

/* ---- Free design-help modal ---- */
(function () {
  function init() {
    var openBtn = document.getElementById('cz-help-btn');
    var modal = document.getElementById('cz-help-modal');
    if (!openBtn || !modal) return;

    var overlay = document.getElementById('cz-help-overlay');
    var closeBtn = document.getElementById('cz-help-close');
    var doneBtn = document.getElementById('cz-help-done');
    var form = document.getElementById('cz-help-form');
    var formWrap = document.getElementById('cz-help-form-wrap');
    var success = document.getElementById('cz-help-success');
    var submitBtn = document.getElementById('cz-help-submit');

    if (openBtn.dataset.czHelpBound) return;
    openBtn.dataset.czHelpBound = '1';

    // The customizer section carries a scroll-reveal transform, and any
    // transformed ancestor becomes the containing block for position:fixed
    // children — which drops this modal into the middle of the (very tall)
    // section instead of the viewport. Re-parenting to <body> keeps it fixed
    // to the screen.
    if (modal.parentNode !== document.body) {
      // Drop a modal left behind by an earlier render (theme editor reloads
      // the section without clearing what we moved out of it).
      document.querySelectorAll('body > .czhelp').forEach(function (stale) {
        if (stale !== modal) stale.remove();
      });
      document.body.appendChild(modal);
    }

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    if (doneBtn) doneBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    /* ── Optional file attachment ──
       Shopify's contact form can't carry a file, so the file goes to the same
       Cloudinary account the customizer already uploads logos to and only the
       resulting URL rides along in a hidden field. Without Cloudinary
       configured there is nowhere to put the file, so the field stays hidden. */
    var fileField = document.getElementById('cz-help-file-field');
    var fileInput = document.getElementById('cz-help-file');
    var fileName = document.getElementById('cz-help-file-name');
    var fileStatus = document.getElementById('cz-help-file-status');
    var fileUrl = document.getElementById('cz-help-file-url');
    var cl = (window.CZ_CONFIG && window.CZ_CONFIG.cloudinary) || {};
    var canAttach = !!(cl.cloudName && cl.preset);
    var MAX_BYTES = 10 * 1024 * 1024;
    var uploading = false;
    var submitWhenUploaded = false;

    if (fileField && canAttach) fileField.hidden = false;

    function setFileStatus(text, kind) {
      if (!fileStatus) return;
      fileStatus.textContent = text;
      fileStatus.className = 'czhelp__file-status' + (kind ? ' is-' + kind : '');
    }

    if (fileInput && canAttach) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (fileUrl) fileUrl.value = '';
        if (!file) {
          if (fileName) { fileName.textContent = 'JPG, PNG, SVG or PDF, up to 10 MB'; fileName.classList.remove('is-set'); }
          setFileStatus('', '');
          return;
        }
        if (fileName) { fileName.textContent = file.name; fileName.classList.add('is-set'); }
        if (file.size > MAX_BYTES) {
          fileInput.value = '';
          if (fileName) { fileName.textContent = 'JPG, PNG, SVG or PDF, up to 10 MB'; fileName.classList.remove('is-set'); }
          setFileStatus('That file is over 10 MB. Please choose a smaller one.', 'error');
          return;
        }

        uploading = true;
        setFileStatus('Uploading…', 'uploading');
        var fd = new FormData();
        fd.append('file', file);
        fd.append('upload_preset', cl.preset);
        fetch('https://api.cloudinary.com/v1_1/' + cl.cloudName + '/auto/upload', { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            uploading = false;
            if (data && data.secure_url) {
              if (fileUrl) fileUrl.value = data.secure_url;
              setFileStatus('✓ File attached', 'done');
            } else {
              setFileStatus('Upload failed. You can still send the request and share the file on the call.', 'error');
            }
            if (submitWhenUploaded) { submitWhenUploaded = false; sendForm(); }
          })
          .catch(function () {
            uploading = false;
            setFileStatus('Upload failed. You can still send the request and share the file on the call.', 'error');
            if (submitWhenUploaded) { submitWhenUploaded = false; sendForm(); }
          });
      });
    }

    function sendForm() {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' }
      })
        .then(function (r) {
          /* When Shopify wants a captcha it redirects to /challenge and the
             request is not saved: a normal submit shows the challenge and
             sends the request once it is solved. */
          if (!r.ok || /\/challenge/.test(r.url || '')) { form.submit(); return; }
          if (formWrap) formWrap.hidden = true;
          if (success) success.hidden = false;
        })
        .catch(function () {
          // Network failure, fall back to a normal submit so the request still sends.
          form.submit();
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        if (uploading) {
          // Send as soon as the attachment lands rather than making them wait on a button.
          submitWhenUploaded = true;
          submitBtn.disabled = true;
          submitBtn.textContent = 'Finishing upload…';
          return;
        }
        sendForm();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
